<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <!-- 选项卡区域 -->
      <div class="section_2 flex-col justify-end">
        <div class="text-wrapper_1 flex-row justify-between">
          <span class="text_2" :class="{ active: currentTab === 'gxy' }" @click="switchTab('gxy')">公学芸</span>
          <span class="text_3" :class="{ active: currentTab === 'xyb' }" @click="switchTab('xyb')">校友帮</span>
        </div>
        <div class="box_4 flex-row">
          <div class="block_1 flex-col"
            :class="{ 'tab-indicator-gxy': currentTab === 'gxy', 'tab-indicator-xyb': currentTab === 'xyb' }"></div>
        </div>
      </div>

      <!-- 搜索区域 -->
      <div class="section_3 flex-row">
        <div class="search-container">
          <van-field v-model="searchKeyword" class="search-input" placeholder="搜索你想要的" clearable
            @keyup.enter="searchAccounts" />
          <div class="search-button" @click="searchAccounts">
            <span class="text_5">搜索</span>
          </div>
        </div>
      </div>
    </div>

    <div class="multi-gxy-tip">
      <strong>可添加多个公学芸账号</strong>
      <span>一个网站账号可绑定多个公学芸账号，分别管理签到服务</span>
    </div>

    <!-- 账户列表 - 可滚动区域 -->
    <div class="accounts-container" v-if="accounts.length > 0">
      <div class="account-item" v-for="(account, index) in accounts" :key="account.phone || index">
        <!-- 账户头部信息 - 始终显示 -->
        <div class="account-header flex-row" @click="toggleAccount(index)">
          <div class="account-info-left">
            <div class="account-name-row">
              <span class="account-name">{{ account.name }}</span>
              <span class="account-phone">{{ formatPhone(account.phone) }}</span>
            </div>
            <div class="account-class-row">
              <div class="status-container">
                <template v-if="currentTab === 'xyb' && account.integration_status === 'legacy'">
                  <span class="tag status-tag status-expired">待重新接入</span>
                </template>
                <template v-else>
                  <span class="tag status-tag" :class="getStatusClass(account.vip_sign_end_time)">
                    {{ getStatusText(account.vip_sign_end_time) }}
                  </span>
                  <span v-if="getRemainingDays(account.vip_sign_end_time) > 0" class="remaining-days-tag">
                    {{ currentTab === 'gxy'
                      ? `自动：${getRemainingDays(account.vip_sign_end_time)}天`
                      : `套餐：${getRemainingDays(account.vip_sign_end_time)}天后到期` }}
                  </span>
                </template>
              </div>
            </div>
          </div>
          <!-- 折叠/展开图标 -->
          <div class="expand-icon" :class="{ 'expanded': account.expanded }">
            <!-- 当前使用CSS箭头 -->
            <!-- <div class="arrow-icon"></div> -->

            <!-- 如果想使用图片，请取消注释下面的代码并注释上面的CSS箭头 -->

            <img 
              :src="account.expanded ? './imgs/Group_326.png' : './imgs/Frame.png'" 
              :alt="account.expanded ? '收起' : '展开'"
              class="icon-image"
            />

          </div>
        </div>

        <!-- 实习计划信息 - 可折叠 -->
        <transition name="slide-fade">
          <div class="account-plan" v-if="account.plan_name && account.expanded">
            <div class="plan-header">
              <span class="plan-title">实习计划</span>
              <div class="plan-date-container">
                <span class="plan-date">{{ account.plan_start }}~{{ account.plan_end }}</span>
                <button v-if="currentTab === 'gxy'" class="refresh-plan-btn" @click="refreshUser(account)" title="刷新用户信息">
                  <van-icon name="replay" />
                </button>
              </div>
            </div>
            <div class="plan-description">{{ account.description }}</div>
          </div>
        </transition>

        <!-- 操作按钮区域 - 可折叠 -->
        <transition name="slide-fade">
          <div class="account-actions" v-if="account.expanded && currentTab === 'xyb' && account.integration_status === 'legacy'">
            <button class="action-btn" @click="reconnectAccount(account)">重新接入</button>
            <button class="action-btn danger" @click="deleteAccount(account.phone)">删除用户</button>
          </div>
          <div class="account-actions" v-else-if="account.expanded">
            <button class="action-btn renew" :class="{'renew-expired': getRemainingDays(account.vip_sign_end_time) <= 0}" @click="renewAccount(account)">续费签到</button>
            <button class="action-btn" @click="settingAccount(account)">签到设置</button>
            <button class="action-btn" @click="submitCheckin(account)">{{ currentTab === 'gxy' && manualProxyWaiting[String(account.phone)] ? '正在获取代理…' : '立即打卡' }}</button>
            <button v-if="currentTab === 'gxy'" class="action-btn makeup-entry" :disabled="!canUseMakeupSign(account)" title="仅自动剩余天数大于0可用" @click="openMakeupSign(account)">补签</button>
            <button v-if="currentTab === 'xyb'" class="action-btn" @click="loadXybLogs(account)">打卡日志</button>
            <button v-if="currentTab === 'gxy'" class="action-btn" @click="generateReport(account)">生成报告</button>
            <button v-if="currentTab === 'gxy'" class="action-btn" @click="checkinRecord(account)">打卡记录</button>
            <button v-if="currentTab === 'gxy'" class="action-btn" @click="generateShareLink(account)">打卡链接</button>
            <button class="action-btn" @click="changePassword(account)">修改密码</button>
            <button class="action-btn danger" @click="deleteAccount(account.phone)">删除用户</button>
          </div>
        </transition>
        <p v-if="currentTab === 'gxy' && account.expanded && !canUseMakeupSign(account)" class="makeup-entitlement-tip">补签仅自动剩余天数大于0可用</p>
      </div>
    </div>

    <!-- 无数据提示 -->
    <div class="no-data" v-else-if="!loading">
      <p>暂无账号数据</p>
    </div>

    <!-- 加载中 -->
    <div class="loading" v-if="loading">
      <p>加载中...</p>
    </div>

    <van-dialog v-model="showMakeupSignDialog" class="history-makeup-dialog" title="补签" :show-confirm-button="false" show-cancel-button cancel-button-text="关闭">
      <div class="makeup-sign-content">
        <div class="makeup-history-scroll">
        <p class="makeup-sign-date">{{ makeupSignAccount ? makeupSignAccount.phone : '' }}</p>
        <p class="makeup-range-tip">可申请过去30天的补卡（不含今天）：{{ makeupRangeStart }} 至 {{ makeupRangeEnd }}</p>
        <p class="makeup-entitlement-tip">仅自动剩余天数大于0可用。申请提交后，以公学芸审批和考勤记录为准。</p>
        <div class="makeup-month-nav">
          <button aria-label="补卡上个月" :disabled="!canMoveMakeupMonth(-1)" @click="moveMakeupMonth(-1)">‹</button>
          <strong>{{ makeupCalendarMonth }}</strong>
          <button aria-label="补卡下个月" :disabled="!canMoveMakeupMonth(1)" @click="moveMakeupMonth(1)">›</button>
        </div>
        <div class="makeup-weekdays"><span v-for="week in ['日','一','二','三','四','五','六']" :key="week">{{ week }}</span></div>
        <div class="makeup-calendar-grid">
          <button v-for="(day, index) in makeupCalendarDays" :key="day.date || 'empty-' + index" class="makeup-calendar-day" :class="{ selected: day.date === makeupSignDate }" :disabled="!day.enabled || makeupRecordsLoading || Boolean(makeupRecordsError)" :aria-label="day.date || '空白日期'" @click="selectMakeupDate(day.date)">
            <span>{{ day.number }}</span>
            <small v-if="day.enabled && !makeupRecordsLoading && !makeupRecordsError">{{ makeupDayMarker(day.date, 'START') }} {{ makeupDayMarker(day.date, 'END') }}</small>
          </button>
        </div>
        <p v-if="makeupRecordsLoading" class="makeup-load-state">正在查询考勤和补卡记录…</p>
        <div v-else-if="makeupRecordsError" class="makeup-load-error">
          <p>{{ makeupRecordsError }}</p>
          <button class="makeup-reload-button" @click="loadMakeupHistories(makeupSignAccount)">重新查询</button>
        </div>
        <p v-else class="makeup-calendar-legend">上 / 下：✓ 已打卡 · 待 申请中 · 拒 已驳回 · 验 需验证 · ? 待确认 · — 未查到记录</p>
        </div>
        <div class="makeup-submit-actions">
        <div v-if="makeupSignDate && !makeupRecordsLoading && !makeupRecordsError" class="makeup-selected-date">
          <strong>{{ makeupSignDate }}</strong>
          <p>上班：{{ makeupRecordState(makeupSignDate, 'START').label }}</p>
          <p>下班：{{ makeupRecordState(makeupSignDate, 'END').label }}</p>
        </div>
        <p v-else-if="!makeupRecordsLoading && !makeupRecordsError" class="makeup-load-state">请先选择需要补卡的日期</p>
        <button class="makeup-sign-button" :disabled="!canSubmitMakeupType('START')" @click="submitMakeupSign('START')">申请补上班卡</button>
        <button class="makeup-sign-button" :disabled="!canSubmitMakeupType('END')" @click="submitMakeupSign('END')">申请补下班卡</button>
        </div>
      </div>
    </van-dialog>

    <!-- 打卡链接弹窗 -->
    <van-dialog v-model="showShareLinkDialog" title="专属打卡链接" :show-cancel-button="false" confirm-button-text="关闭">
      <div class="share-link-content">
        <p class="share-link-tip">将此链接发送给用户，打开即可一键打卡：</p>
        <div class="share-link-box">
          <span class="share-link-text">{{ shareLink }}</span>
        </div>
        <button class="copy-link-btn" @click="copyShareLink">复制链接</button>
      </div>
    </van-dialog>

    <!-- 校友邦打卡日志 -->
    <van-dialog v-model="showXybLogsDialog" title="打卡日志" :show-cancel-button="false" confirm-button-text="关闭">
      <div class="xyb-log-list">
        <div v-if="xybLogs.length === 0" class="no-data">暂无日志</div>
        <div v-for="log in xybLogs" :key="log.id || log.time" class="xyb-log-item">
          <div class="xyb-log-header">
            <span>{{ log.mark || log.type || '任务日志' }}</span>
            <span>{{ log.time || '' }}</span>
          </div>
          <div class="xyb-log-content">{{ log.content || '' }}</div>
        </div>
      </div>
    </van-dialog>

    <!-- 套餐选择弹窗 -->
    <van-dialog v-model="showPackageDialog" title="续费签到" show-cancel-button @confirm="buyPackage">
      <div style="padding: 16px 20px 4px;">
      <van-radio-group v-model="selectedPackage">
        <van-radio v-if="currentTab === 'gxy'" name="11" style="margin-bottom: 6px;">周卡 - 5积分 / 5元</van-radio>
        <van-radio v-if="currentTab === 'gxy'" name="13" style="margin-bottom: 6px;">季卡 - 35积分 / 35元（93天）</van-radio>
        <van-radio name="14" :class="{ 'pkg-half': currentTab === 'gxy' }">
          <span class="pkg-line pkg-half-line" v-if="currentTab === 'gxy'">
            半年卡 - 39积分 / 39元
            <span class="pkg-promo-tag">限时特惠</span>
            <span class="pkg-promo-tag pkg-tag-best">最划算</span>
          </span>
          <span class="pkg-line" v-else>半年卡 - 68.8积分 / 68.8元</span>
          <span class="pkg-promo-sub" v-if="currentTab === 'gxy'">
            <span class="pkg-origin">原价69元</span>
            <span class="pkg-save">立省30元</span>
            <span class="pkg-per-day">日均0.22元</span>
          </span>
        </van-radio>
      </van-radio-group>
      <div style="margin-top: 14px; font-size: 14px; font-weight: bold; color: #323233;">支付方式（1积分=1元）</div>
      <van-radio-group v-model="selectedPayMethod" direction="horizontal" style="margin-top: 8px;">
        <van-radio name="points">积分支付</van-radio>
        <van-radio v-if="currentTab === 'gxy'" name="wechat">微信支付</van-radio>
      </van-radio-group>
      </div>
    </van-dialog>
    <!-- 签到设置弹窗 -->
    <van-dialog v-model="showSettingDialog" title="编辑打卡内容" show-cancel-button @confirm="saveSignConfig">
      <div v-if="selectedAccount" class="sign-config" @scroll="handleScrollIndicator" ref="signConfigContainer">
        <!-- 滚动提示指示器 -->
        <div class="scroll-indicator" :class="{ 'show': showScrollIndicator }">
          <div class="scroll-tip">
            <van-icon name="arrow-down" />
            <span>向下滑动查看更多</span>
          </div>
        </div>
        <!-- 地址信息 -->
        <div class="config-section">
          <h4>地址信息</h4>
          <div class="address-search-wrapper">
            <van-field 
              v-model="signConfig.address" 
              label="公司地址" 
              placeholder="🔍 点击此处搜索公司地址" 
              readonly
              @click="openAddressSearch"
              is-link
            >
              <template #button>
                <van-button 
                  size="small" 
                  type="primary" 
                  @click="openAddressSearch"
                  icon="search"
                >
                  搜索地址
                </van-button>
              </template>
            </van-field>
            <div class="search-tip">💡 支持搜索公司名称、地标建筑或详细地址，自动获取经纬度信息</div>
          </div>
          <van-field v-model="signConfig.province" label="*省" placeholder="新疆维吾尔自治区" />
          <van-field v-model="signConfig.city" label="*市" placeholder="和田地区" />
          <van-field v-model="signConfig.district" label="*区" placeholder="和田县" />
          <van-field v-model="signConfig.detailAddress" label="*详细地址" placeholder="在和田县水利局巴格其水管站附近" />
          <van-field v-model="signConfig.longitude" label="*经度" placeholder="79.7679600000" />
          <van-field v-model="signConfig.latitude" label="*纬度" placeholder="37.0915330000" />
        </div>

        <!-- 时间设置 -->
        <div class="config-section">
          <h4>时间设置</h4>
          <van-field v-model="signConfig.workStartTime" label="上班时间" placeholder="8:00:00" />
          <van-field v-model="signConfig.workEndTime" label="下班时间" placeholder="17:30:00" />
        </div>

        <!-- 打卡照片 -->
        <div v-if="currentTab === 'gxy'" class="config-section">
          <h4>打卡照片</h4>
          <p class="photo-desc">可传多张,打卡时随机选一张</p>
          <van-uploader
            v-model="signConfig.uploadImages"
            multiple
            :max-count="5"
            :after-read="afterRead"
            :before-delete="beforeDelete"
            accept="image/*"
          >
            <div class="photo-placeholder">
              <van-icon name="photograph" />
              <span>点击上传</span>
            </div>
          </van-uploader>
        </div>

        <!-- 打卡周期 -->
        <div class="config-section">
          <h4>打卡周期</h4>
          <van-checkbox-group v-model="signConfig.checkinDays">
            <van-checkbox name="1">周一</van-checkbox>
            <van-checkbox name="2">周二</van-checkbox>
            <van-checkbox name="3">周三</van-checkbox>
            <van-checkbox name="4">周四</van-checkbox>
            <van-checkbox name="5">周五</van-checkbox>
            <van-checkbox name="6">周六</van-checkbox>
            <van-checkbox name="7">周日</van-checkbox>
          </van-checkbox-group>
        </div>

        <!-- 启用开关 -->
        <div class="config-section">
          <div class="toggle-item">
            <span>{{ currentTab === 'xyb' ? '启用自动签到' : '启用上班打卡' }}</span>
            <van-switch v-model="signConfig.enableWorkStart" />
            <span class="toggle-desc">上面可设定时间</span>
          </div>
          <div class="toggle-item">
            <span>启用下班打卡</span>
            <van-switch v-model="signConfig.enableWorkEnd" />
            <span class="toggle-desc">上面可设定时间</span>
          </div>
          <div class="toggle-item">
            <span>启用自动日报</span>
            <van-switch v-model="signConfig.autoDayReport" />
            <span class="toggle-desc">每天提交</span>
          </div>
          <div class="toggle-item">
            <span>启用自动周报</span>
            <van-switch v-model="signConfig.autoWeekReport" />
            <span class="toggle-desc">每周日提交</span>
          </div>
          <div class="toggle-item">
            <span>启用自动月报</span>
            <van-switch v-model="signConfig.autoMonthReport" />
            <span class="toggle-desc">每月月底提交</span>
          </div>
        </div>
      </div>
    </van-dialog>

    <!-- 打卡记录弹窗 -->
    <van-dialog v-model="showRecordDialog" title="签到历史" show-cancel-button @confirm="showRecordDialog = false">
      <div v-if="selectedAccount" class="calendar-container">
        <div class="calendar-header">
          <div class="month-year">{{ currentMonthYear }}</div>
          <div class="weekdays">
            <span>日</span>
            <span>一</span>
            <span>二</span>
            <span>三</span>
            <span>四</span>
            <span>五</span>
            <span>六</span>
          </div>
        </div>

        <div class="calendar-grid">
          <div v-for="day in calendarDays" :key="day.date" class="calendar-day" :class="{
            'empty': !day.date,
            'current': day.isCurrent,
            'has-record': day.hasRecord,
            'selected': day.isSelected
          }" @click="selectDate(day)">
            <span class="day-number">{{ day.dayNumber }}</span>
            <div v-if="day.hasRecord" class="record-indicator"></div>
          </div>
        </div>

        <!-- 选中日期的详细记录 -->
        <div v-if="selectedDateRecords.length > 0" class="selected-date-records">
          <h4>{{ formatSelectedDate() }} 打卡记录</h4>
          <div v-for="record in selectedDateRecords" :key="record.attendanceId" class="record-item">
            <div class="record-time">
              <span class="time">{{ formatTime(record.createTime) }}</span>
              <span class="type" :class="record.type === 'START' ? 'start' : 'end'">
                {{ record.type === 'START' ? '上班' : '下班' }}
              </span>
            </div>
            <div class="record-address">{{ record.address }}</div>
          </div>
        </div>
      </div>
    </van-dialog>

    <!-- 生成报告弹窗 -->
    <van-dialog v-model="showReportDialog" title="生成报告" show-cancel-button @confirm="showReportDialog = false">
      <div v-if="selectedAccount" class="report-container">
        <!-- 标签页切换 -->
        <div class="tab-container">
          <div 
            class="tab-item" 
            :class="{ active: activeTab === 'report' }"
            @click="switchReportTab('report')"
          >
            生成报告
          </div>
          <div 
            class="tab-item" 
            :class="{ active: activeTab === 'recent' }"
            @click="switchReportTab('recent')"
          >
            最近记录
          </div>
        </div>

        <!-- 生成报告标签页 -->
        <div v-if="activeTab === 'report'" class="tab-content">
          <!-- 报告类型选择 -->
          <div class="report-type-selector">
            <label class="form-label">报告类型</label>
            <van-radio-group v-model="reportForm.type" @change="onReportTypeChange">
              <van-radio name="daily">日报</van-radio>
              <van-radio name="weekly">周报</van-radio>
              <van-radio name="monthly">月报</van-radio>
            </van-radio-group>
          </div>

          <!-- 最近记录链接 -->
          <div class="recent-records-link" @click="switchReportTab('recent')">
            <span>查看最近10条记录</span>
            <van-icon name="arrow" />
          </div>

          <!-- 周次选择 -->
          <div v-if="reportForm.type === 'weekly'" class="week-selector">
            <label class="form-label">补写周次</label>
            <div class="week-display" @click="openWeekSelector">
              <span>{{ getWeekDisplayText() }}</span>
              <van-icon name="arrow" />
            </div>
          </div>

          <!-- 日期选择 (仅日报显示) -->
          <div v-if="reportForm.type === 'daily'" class="date-selector">
            <label class="form-label">补写日期</label>
            <div class="date-display" @click="openDateSelector">
              <span>{{ reportForm.reportTime || '请选择日期' }}</span>
              <van-icon name="arrow" />
            </div>
          </div>

          <!-- 月份选择 (仅月报显示) -->
          <div v-if="reportForm.type === 'monthly'" class="month-selector">
            <label class="form-label">补写月份</label>
            <div class="month-display" @click="openMonthSelector">
              <span>{{ reportForm.month || '请选择月份' }}</span>
              <van-icon name="arrow" />
            </div>
          </div>

          <!-- 报告标题 -->
          <div class="form-section">
            <label class="form-label">报告标题</label>
            <van-field v-model="reportForm.title" placeholder="请输入报告标题" readonly />
          </div>

          <!-- 报告内容 -->
          <div class="form-section">
            <label class="form-label">报告内容</label>
            <div class="content-area">
              <button class="ai-generate-btn" @click="generateAIContent">AI生成报告</button>
              <textarea 
                v-model="reportForm.content" 
                placeholder="请输入内容"
                maxlength="1000"
                class="content-textarea"
              ></textarea>
              <div class="char-count">{{ reportForm.content.length }}/1000</div>
            </div>
          </div>

          <!-- 提交按钮 -->
          <div class="form-actions">
            <van-button type="primary" @click="submitReport" :loading="submitting" class="submit-btn">提交报告</van-button>
          </div>
        </div>

        <!-- 最近记录标签页 -->
        <div v-if="activeTab === 'recent'" class="tab-content">
          <div class="recent-reports-section">
            <div class="section-header">
              <span class="section-title">最近记录</span>
              <button class="refresh-btn" @click="loadRecentReports(selectedAccount.phone)">
                <van-icon name="replay" />
                刷新
              </button>
            </div>
            
            <div v-if="recentReports.length === 0" class="no-reports-message">
              暂无{{ getReportTypeText(reportForm.report_type) }}记录
            </div>
            <div v-else class="recent-reports-list">
              <div v-for="(report, index) in recentReports" :key="index" class="report-item">
                <div class="report-header">
                  <span class="report-title">{{ report.title || report.report_title }}</span>
                  <span class="report-date">{{ formatDate(report.createTime) }}</span>
                </div>
                <div class="report-content">{{ formatReportContent(report.content || report.report_content) }}</div>
                <div class="report-meta">
                  <span class="report-type">{{ getReportTypeText(report.reportType) }}</span>
                  <span class="report-week">{{ report.weeks }}</span>
                  <span class="report-score" v-if="report.score > 0">评分: {{ report.score }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>

    <!-- 修改密码弹窗 -->
    <van-dialog v-model="showPasswordDialog" title="修改密码" show-cancel-button @confirm="confirmChangePassword">
      <van-field v-model="newPassword" type="password" label="新密码" placeholder="请输入新密码" />
    </van-dialog>

    <!-- 删除确认弹窗 -->
    <van-dialog v-model="showDeleteDialog" title="" :show-cancel-button="false" :show-confirm-button="false"
      class="delete-dialog">
      <div class="delete-warning">
        <div class="warning-icon">⚠️</div>
        <div class="warning-title">警告</div>
        <div class="warning-message">
          此操作将会从数据库移除该账户(及套餐), 删除后,你需要重新添加。
        </div>
        <div class="delete-actions">
          <button class="delete-cancel" @click="showDeleteDialog = false">取消</button>
          <div class="action-divider"></div>
          <button class="delete-confirm" @click="confirmDelete">确认</button>
        </div>
      </div>
    </van-dialog>



    <!-- 地址搜索弹窗 -->
    <AddressSearchModal 
      v-model="showAddressSearchDialog" 
      @select="onAddressSelect" 
    />

    <!-- 计划选择弹窗 -->
    <van-dialog 
      v-model="showPlanSelectDialog" 
      title="选择实习计划" 
      show-cancel-button 
      @confirm="selectPlan"
      @cancel="showPlanSelectDialog = false"
    >
      <div class="plan-select-content">
        <div class="plan-select-tip">
          <van-icon name="info-o" />
          <span>检测到该账号有多个实习计划，请选择要使用的计划：</span>
        </div>
        <van-radio-group v-model="selectedPlanId">
          <div v-for="(plan, index) in planSelectData.plans" :key="plan.planId || index" class="plan-item">
            <van-radio :name="plan.planId" class="plan-radio">
              <template #icon="props">
                <div class="radio-icon" :class="{ checked: props.checked }">
                  <van-icon v-if="props.checked" name="success" />
                </div>
              </template>
            </van-radio>
            <div class="plan-info">
              <div class="plan-name">{{ plan.planName }}</div>
              <div class="plan-time">{{ formatPlanTime(plan.startTime, plan.endTime) }}</div>
              <div class="plan-type">{{ plan.type || '工学实习' }}</div>
            </div>
          </div>
        </van-radio-group>
      </div>
    </van-dialog>

    <!-- 底部导航栏 -->
    <BottomNavigation :currentRoute="$route.path" />
  </div>
</template>
<script>
import axios from 'axios'
import { Toast, Dialog } from 'vant'
import BottomNavigation from '@/components/BottomNavigation.vue'
import AddressSearchModal from '@/components/AddressSearchModal.vue'
import { API_ENDPOINTS, TIMEOUT_CONFIG } from '@/config/api'
import { createSignOperationManager, createSignPendingStore, isSameSignDay, beijingSignDate, sameSignIntent, historicalMakeupRange, isHistoricalMakeupDate } from '@/utils/signOperation'
import { waitForManualProxy } from '@/utils/manualProxyWait'

const ACCOUNT_ALIPAY_PENDING_KEY = 'account_sign_alipay_pending'
const ALIPAY_PENDING_TTL = 10 * 60 * 1000
const WECHAT_ALIPAY_TIP = '微信无法跳转支付宝，请浏览器打开网站'

export default {
  components: {
    BottomNavigation,
    AddressSearchModal
  },

  data() {
    return {
      accounts: [],
      allAccounts: [],
      searchKeyword: '',
      loading: false,
      currentTab: 'gxy', // 默认显示公学芸
      showPackageDialog: false,
      selectedPayMethod: 'points',
      showSettingDialog: false,
      showScrollIndicator: true,
      showRecordDialog: false,
      showPasswordDialog: false,
      showReportDialog: false,
      showDeleteDialog: false,
      showAddressSearchDialog: false,
      showPlanSelectDialog: false,
      showShareLinkDialog: false,
      showXybLogsDialog: false,
      showMakeupSignDialog: false,
      makeupSignAccount: null,
      makeupSignDate: '',
      makeupWindowDate: '',
      makeupRangeStart: '',
      makeupRangeEnd: '',
      makeupCalendarMonth: '',
      makeupCalendarDays: [],
      makeupRecordsLoading: false,
      makeupRecordsError: '',
      makeupHistoryPhone: '',
      makeupRecordRows: [],
      makeupApplicationRows: [],
      shareLink: '',
      deletePhone: '',
      selectedAccount: null,
      selectedPackage: '',
      newPassword: '',
      checkinRecords: [],
      xybLogs: [],
      planSelectData: {
        account: null,
        plans: []
      },
      selectedPlanId: '',
      calendarDays: [],
      currentMonthYear: '',
      selectedDate: null,
      selectedDateRecords: [],
      signConfig: { // 签到设置配置
        address: '',
        province: '',
        city: '',
        district: '',
        detailAddress: '',
        longitude: '',
        latitude: '',
        workStartTime: '8:00:00',
        workEndTime: '17:30:00',
        checkinDays: ['1', '2', '3', '4', '5', '6', '7'],
        enableWorkStart: true,
        enableWorkEnd: true,
        autoDayReport: false,
        autoWeekReport: false,
        autoMonthReport: false,
        uploadImages: []
      },
      reportForm: { // 报告表单
        type: 'daily',
        title: '',
        content: '',
        phone: '',
        report_type: 'day',
        report_flag: 0,
        report_title: '',
        report_content: '',
        reportTime: '',
        startTime: '',
        endTime: '',
        week: 0,
        yearmonth: ''
      },
      recentReports: [], // 新增：最近报告列表
      submitting: false, // 新增：提交报告时的加载状态
      manualProxyWaiting: {},
      activeTab: 'report', // 新增：当前标签页
      weeksData: [], // 新增：周次数据列表
      monthsData: [], // 新增：月份数据列表
    };
  },
  async mounted() {
    this._manualProxyWaitStopped = false;
    window.addEventListener('pagehide', this.stopManualProxyWaiting);
    window.addEventListener('pageshow', this.resumeManualProxyPage);
    if (this.$route.query.tab === 'xyb' || this.$route.query.tab === 'gxy') {
      this.currentTab = this.$route.query.tab;
    }
    this.bindAlipayReturnEvents();
    await this.getAccountList();
    this.checkAlipayReturn();
  },
  beforeDestroy() {
    this.stopManualProxyWaiting();
    window.removeEventListener('pagehide', this.stopManualProxyWaiting);
    window.removeEventListener('pageshow', this.resumeManualProxyPage);
    this._makeupHistoryRequest = (this._makeupHistoryRequest || 0) + 1;
    this.unbindAlipayReturnEvents();
    if (this._alipayRetryTimer) {
      clearTimeout(this._alipayRetryTimer);
    }
  },
  methods: {
    stopManualProxyWaiting() {
      this._manualProxyWaitStopped = true;
      this._manualProxyWaitEpoch = (this._manualProxyWaitEpoch || 0) + 1;
    },
    resumeManualProxyPage() {
      this._manualProxyWaitStopped = false;
    },
    getSignOperationManager() {
      if (!this._signOperationManager) {
        this._signOperationManager = createSignOperationManager('account', ALIPAY_PENDING_TTL);
      }
      return this._signOperationManager;
    },

    isWeChatBrowser() {
      return /MicroMessenger/i.test(navigator.userAgent || '')
    },

    getAccountAlipayPending() {
      const store = this.getAccountAlipayPendingStore();
      try {
        const pending = store.read();
        if (!pending) return null;
        if (!pending || !pending.phone || !pending.createdAt || !pending.operation) {
          store.clear();
          return null;
        }
        if (pending.operation.mode === 'historical_makeup' &&
            (!isHistoricalMakeupDate(pending.operation.signDate) || !isSameSignDay(pending.createdAt))) {
          store.clear();
          this.showToast('操作日期已变化，请重新打开补签并选择日期和类型');
          return null;
        }
        const operation = this.getSignOperationManager().read(pending.phone);
        if (Date.now() - pending.createdAt > ALIPAY_PENDING_TTL || !isSameSignDay(pending.createdAt) ||
            !operation || operation.id !== pending.operation.id || ['success', 'failed'].includes(operation.state)) {
          store.clear();
          return null;
        }
        return pending;
      } catch (e) {
        store.clear();
        return null;
      }
    },

    getAccountAlipayPendingStore() {
      if (!this._alipayPendingStore) this._alipayPendingStore = createSignPendingStore(ACCOUNT_ALIPAY_PENDING_KEY);
      return this._alipayPendingStore;
    },

    saveAccountAlipayPending(pending) {
      this.getAccountAlipayPendingStore().save(pending);
    },

    clearAccountAlipayPending(operation) {
      const pending = this.getAccountAlipayPending();
      if (pending && operation && pending.operation.id !== operation.id) return;
      if (this._alipayRetryTimer) {
        clearTimeout(this._alipayRetryTimer);
        this._alipayRetryTimer = null;
      }
      this.getAccountAlipayPendingStore().clear();
    },

    prepareAccountAlipayPending(account, operation) {
      const manager = this.getSignOperationManager();
      if (!manager.matches(String(account.phone), operation) ||
          manager.read(String(account.phone)).state !== 'awaiting_auth') return false;
      this.clearAccountAlipayPending();
      this.saveAccountAlipayPending({
        phone: String(account.phone),
        tab: 'gxy',
        operation,
        createdAt: Date.now(),
        leftPage: false,
        retryConsumed: false,
      });
      return true;
    },

    markAlipayPageLeft() {
      const pending = this.getAccountAlipayPending();
      if (!pending || pending.retryConsumed || pending.leftPage) return;
      pending.leftPage = true;
      this.saveAccountAlipayPending(pending);
    },

    bindAlipayReturnEvents() {
      this._onAlipayVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
          this.markAlipayPageLeft();
        } else {
          this.checkAlipayReturn();
        }
      };
      this._onAlipayPageBlur = () => this.markAlipayPageLeft();
      this._onAlipayPageHide = () => this.markAlipayPageLeft();
      this._onAlipayPageFocus = () => this.checkAlipayReturn();
      this._onAlipayPageShow = () => this.checkAlipayReturn();
      document.addEventListener('visibilitychange', this._onAlipayVisibilityChange);
      window.addEventListener('blur', this._onAlipayPageBlur);
      window.addEventListener('pagehide', this._onAlipayPageHide);
      window.addEventListener('focus', this._onAlipayPageFocus);
      window.addEventListener('pageshow', this._onAlipayPageShow);
    },

    unbindAlipayReturnEvents() {
      document.removeEventListener('visibilitychange', this._onAlipayVisibilityChange);
      window.removeEventListener('blur', this._onAlipayPageBlur);
      window.removeEventListener('pagehide', this._onAlipayPageHide);
      window.removeEventListener('focus', this._onAlipayPageFocus);
      window.removeEventListener('pageshow', this._onAlipayPageShow);
    },

    checkAlipayReturn() {
      const pending = this.getAccountAlipayPending();
      if (!pending || pending.retryConsumed || !pending.leftPage) return;
      if (document.visibilityState === 'hidden' || this._alipayAutoRetryRunning) return;
      if (this._alipayRetryTimer) {
        clearTimeout(this._alipayRetryTimer);
        this._alipayRetryTimer = null;
      }
      this._alipayRetryTimer = setTimeout(() => {
        this.retryAccountSignAfterAlipay(pending.operation);
      }, 1800);
    },

    async retryAccountSignAfterAlipay(expectedOperation) {
      const pending = this.getAccountAlipayPending();
      if (!pending || pending.retryConsumed || !pending.leftPage || this._alipayAutoRetryRunning) return;
      if (expectedOperation && (expectedOperation.id !== pending.operation.id || expectedOperation.step !== pending.operation.step)) return;
      if (!this.getSignOperationManager().matches(pending.phone, pending.operation) ||
          (this._signRequests && this._signRequests[`gxy:${pending.phone}`])) return;

      // Consume the queued callback before starting the single continuation.
      if (this._alipayRetryTimer) {
        clearTimeout(this._alipayRetryTimer);
        this._alipayRetryTimer = null;
      }
      if (document.visibilityState === 'hidden') return;

      this._alipayAutoRetryRunning = true;
      try {
        const current = this.getAccountAlipayPending();
        if (!current || current.retryConsumed || current.operation.id !== pending.operation.id ||
            current.operation.step !== pending.operation.step ||
            !this.getSignOperationManager().matches(pending.phone, pending.operation) ||
            (this._signRequests && this._signRequests[`gxy:${pending.phone}`])) return;
        current.retryConsumed = true;
        this.saveAccountAlipayPending(current);
        this.showToast(pending.operation.mode === 'historical_makeup'
          ? `正在提交${pending.operation.signDate}${pending.operation.signType === 'START' ? '上班' : '下班'}补卡申请...`
          : '正在继续提交本次打卡...');
        await this.submitCheckin(
          { phone: pending.phone },
          { isAlipayAutoRetry: true, tab: pending.tab || 'gxy', operation: pending.operation }
        );
      } finally {
        this._alipayAutoRetryRunning = false;
      }
    },

    showToast(message) {
      Toast(message);
    },

    showAlipayVerification(data, account, operation) {
      const url = data.url || '';
      const operationTip = operation && operation.mode === 'historical_makeup'
        ? `本次申请：${operation.signDate} ${operation.signType === 'START' ? '上班' : '下班'}卡。\n`
        : '';
      const tip = operationTip + (data.tip || '需要完成支付宝人脸认证');
      if (this.isWeChatBrowser()) {
        this.clearAccountAlipayPending(operation);
        Dialog.alert({
          title: '无法跳转支付宝',
          message: WECHAT_ALIPAY_TIP,
          confirmButtonText: '我知道了',
        }).catch(() => {});
        return;
      }
      if (url) {
        if (url.startsWith('alipays://') || url.startsWith('alipay://')) {
          Dialog.confirm({
            title: '需要支付宝认证',
            message: tip + '\n\n认证完成返回本页后将自动继续打卡',
            confirmButtonText: '打开支付宝',
            cancelButtonText: '取消',
          }).then(() => {
            if (!this.prepareAccountAlipayPending(account, operation)) return;
            var a = document.createElement('a');
            a.href = url;
            a.setAttribute('target', '_blank');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }).catch(() => {});
        } else {
          Dialog.confirm({
            title: '需要支付宝认证',
            message: tip + '\n\n认证完成返回本页后将自动继续打卡',
            confirmButtonText: '前往认证',
            cancelButtonText: '取消',
          }).then(() => {
            if (!this.prepareAccountAlipayPending(account, operation)) return;
            window.location.href = url;
          }).catch(() => {});
        }
      } else {
        this.showToast(tip);
      }
    },

    // 处理滚动指示器
    handleScrollIndicator(event) {
      const container = event.target;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      
      // 如果滚动超过50px或者接近底部，隐藏指示器
      if (scrollTop > 50 || (scrollTop + clientHeight >= scrollHeight - 20)) {
        this.showScrollIndicator = false;
      } else {
        this.showScrollIndicator = true;
      }
    },

    // 切换选项卡
    async switchTab(tab) {
      this.currentTab = tab;
      this.searchKeyword = '';
      await this.getAccountList();
    },

    // 获取账号列表
    async getAccountList() {
      this.loading = true;
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        // 根据当前选项卡选择不同的API
        const apiUrl = this.currentTab === 'gxy'
          ? API_ENDPOINTS.GXY.GET_USER_LIST
          : API_ENDPOINTS.XYB.GET_USER_LIST;

        const res = await axios.get(apiUrl, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          timeout: TIMEOUT_CONFIG.TASK_LIST  // 设置15秒超时，因为task_list接口响应较慢
        });

        if (res.data.code === 0) {
          // 处理接口返回的数据，映射字段名
          this.accounts = (res.data.data || []).map(account => ({
            // 基本信息
            name: account.userName || account.nikeName || '未知用户',
            phone: account.phone,
            class_name: account.className || '未知班级',
            school_name: account.schoolName,

            // 计划信息
            plan_name: account.PlanName,
            plan_start: account.PlanStartTime ? this.formatDate(account.PlanStartTime) : '',
            plan_end: account.PlanEndTime ? this.formatDate(account.PlanEndTime) : '',

            // 状态信息
            status: account.status,
            integration_status: account.integration_status || 'connected',
            remote_mark: account.remote_mark,
            vip_sign_end_time: account.vip_sign_end_time,
            vip_report_end_time: account.vip_report_end_time,

            // 位置信息
            province: account.province,
            city: account.city,
            area: account.area,
            address: account.address,
            longitude: account.longitude,
            latitude: account.latitude,
            SignStartTime: account.SignStartTime,
            SignEndTime: account.SignEndTime,
            SignDayEable: account.SignDayEable,
            AutoSignStart: account.AutoSignStart,
            AutoSignEnd: account.AutoSignEnd,
            AutoDayReport: account.AutoDayReport,
            AutoWeekReport: account.AutoWeekReport,
            AutoMonthReport: account.AutoMonthReport,
            upload_imgs: account.upload_imgs,

            // 描述信息（组合显示）
            description: this.generateDescription(account),

            // 原始数据
            raw_data: account,

            // 折叠/展开状态
            expanded: true // 默认展开状态
          }));
          this.allAccounts = this.accounts.slice();
        } else {
          this.showToast(res.data.message || '获取账号列表失败');
        }
      } catch (error) {
        console.error('获取账号列表失败:', error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          this.$router.push('/lanhu_yonghudenglu');
        } else {
          this.showToast('获取账号列表失败，请重试');
        }
      } finally {
        this.loading = false;
      }
    },

    // 搜索账号
    async searchAccounts() {
      if (!this.searchKeyword.trim()) {
        this.accounts = this.allAccounts.slice();
        return;
      }
      const keyword = this.searchKeyword.trim().toLowerCase();
      this.accounts = this.allAccounts.filter(account => {
        return [account.name, account.phone, account.class_name, account.plan_name]
          .some(value => String(value || '').toLowerCase().includes(keyword));
      });
    },

    // 添加校友帮账号
    async addAccount() {
      this.$router.push('/lanhu_tianjiazhanghao?platform=xyb');
    },

    reconnectAccount(account) {
      this.$router.push(`/lanhu_tianjiazhanghao?platform=xyb&phone=${encodeURIComponent(account.phone)}`);
    },

    // 续费签到
    async renewAccount(account) {
      try {
        console.log('续费签到被点击', account);
        this.selectedAccount = account;
        // 每次打开都重置, 避免沿用上一个标签页的套餐/支付方式
        this.selectedPackage = '';
        this.selectedPayMethod = 'points';

        // 显示套餐选择弹窗
        this.showPackageDialog = true;
        console.log('弹窗状态:', this.showPackageDialog);
      } catch (error) {
        console.error('续费签到失败:', error);
        this.showToast('续费签到失败');
      }
    },

    // 签到设置
    async settingAccount(account) {
      try {
        console.log('签到设置被点击', account);
        // 跳转到签到设置页面或显示设置弹窗
        this.showSettingDialog = true;
        this.showScrollIndicator = true; // 重置滚动指示器
        this.selectedAccount = account;
        console.log('弹窗状态:', this.showSettingDialog);
        // 初始化签到配置 - 先获取后端配置数据
        await this.loadSignConfig(account.phone);

        // 如果没有配置数据，使用默认值
        if (!this.signConfig.province) {
          this.signConfig = {
            address: account.sign_address || '',
            province: account.province || '',
            city: account.city || '',
            district: account.area || '',
            detailAddress: account.address || '',
            longitude: account.longitude || '',
            latitude: account.latitude || '',
            workStartTime: account.SignStartTime || '8:00:00',
            workEndTime: account.SignEndTime || '17:30:00',
            checkinDays: account.SignDayEable ? account.SignDayEable.split(',') : ['1', '2', '3', '4', '5', '6', '7'],
            enableWorkStart: account.AutoSignStart !== false,
            enableWorkEnd: account.AutoSignEnd !== false,
            autoDayReport: account.AutoDayReport || false,
            autoWeekReport: account.AutoWeekReport || false,
            autoMonthReport: account.AutoMonthReport || false,
            uploadImages: account.upload_imgs || []
          };
        }
      } catch (error) {
        console.error('签到设置失败:', error);
        this.showToast('签到设置失败');
      }
    },

    makeupExpiryMillis(value) {
      if (typeof value !== 'string') return NaN;
      let text = value.trim();
      const legacy = text.match(/^(Sun|Mon|Tue|Wed|Thu|Fri|Sat), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{2}):(\d{2}):(\d{2}) GMT$/);
      if (legacy) {
        // task_list uses Flask's HTTP-date serialization for naive Beijing DB
        // datetimes. Its GMT suffix is a legacy label, not the stored timezone.
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = String(months.indexOf(legacy[3]) + 1).padStart(2, '0');
        text = `${legacy[4]}-${month}-${legacy[2]} ${legacy[5]}:${legacy[6]}:${legacy[7]}`;
      }
      const match = text.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,6}))?(Z|[+-]\d{2}:\d{2})?$/);
      if (!match) return NaN;
      const [year, month, day, hour, minute, second] = match.slice(1, 7).map(Number);
      if (year < 1000 || month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59 || second > 59) return NaN;
      const utc = Date.UTC(year, month - 1, day, hour, minute, second);
      const calendar = new Date(utc);
      if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return NaN;
      if (legacy && ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][calendar.getUTCDay()] !== legacy[1]) return NaN;
      // Database timestamps without an offset are Beijing time, regardless of browser timezone.
      let offsetMinutes = 8 * 60;
      if (match[8] === 'Z') offsetMinutes = 0;
      else if (match[8]) {
        const offsetHours = Number(match[8].slice(1, 3));
        const offsetRemainder = Number(match[8].slice(4, 6));
        if (offsetHours > 14 || offsetRemainder > 59 || (offsetHours === 14 && offsetRemainder !== 0)) return NaN;
        offsetMinutes = (offsetHours * 60 + offsetRemainder) * (match[8][0] === '-' ? -1 : 1);
      }
      return utc - offsetMinutes * 60 * 1000 + Number((match[7] || '').padEnd(3, '0').slice(0, 3));
    },

    canUseMakeupSign(account) {
      if (!account || !account.phone) return false;
      const phone = String(account.phone);
      const latest = (this.accounts || []).find(item => String(item.phone) === phone)
        || (this.allAccounts || []).find(item => String(item.phone) === phone)
        || account;
      return this.makeupExpiryMillis(latest.vip_sign_end_time) > Date.now();
    },

    async openMakeupSign(account) {
      if (this.currentTab !== 'gxy') return;
      if (!this.canUseMakeupSign(account)) {
        this.showMakeupSignDialog = false;
        this.showToast('补签仅自动剩余天数大于0可用，请先续费自动签到');
        return 'expired';
      }
      this.makeupSignAccount = account;
      this.makeupSignDate = '';
      this.makeupWindowDate = beijingSignDate();
      const range = historicalMakeupRange();
      this.makeupRangeStart = range.start;
      this.makeupRangeEnd = range.end;
      this.makeupCalendarMonth = range.end.slice(0, 7);
      this.renderMakeupCalendar();
      this.showMakeupSignDialog = true;
      return this.loadMakeupHistories(account);
    },

    async loadMakeupHistories(account) {
      if (!account || !account.phone) return false;
      const phone = String(account.phone);
      const requestId = (this._makeupHistoryRequest || 0) + 1;
      this._makeupHistoryRequest = requestId;
      this.makeupRecordsLoading = true;
      this.makeupRecordsError = '';
      this.makeupHistoryPhone = '';
      this.makeupRecordRows = [];
      this.makeupApplicationRows = [];
      const isCurrent = () => this._makeupHistoryRequest === requestId && this.showMakeupSignDialog &&
        this.makeupSignAccount && String(this.makeupSignAccount.phone) === phone;
      try {
        const response = await axios.get(API_ENDPOINTS.GXY.GET_MAKEUP_HISTORIES, {
          params: { phone },
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        });
        if (!isCurrent()) return false;
        const result = response.data || {};
        const data = result.data || {};
        if (result.code !== 0 || !Array.isArray(data.records) || !Array.isArray(data.applications)) {
          this.makeupRecordsError = result.code === 0 ? '记录返回格式异常，请重新查询后再申请补卡'
            : (result.message || '记录查询失败，请重新查询后再申请补卡');
          return false;
        }
        const validIdentity = row => row && ['START', 'END'].includes(row.sign_type) && isHistoricalMakeupDate(row.sign_date);
        if (!data.records.every(row => validIdentity(row) && ['recorded', 'pending', 'rejected'].includes(row.status)) ||
            !data.applications.every(row => validIdentity(row) &&
              ['submitted', 'pending', 'unknown', 'awaiting_auth', 'already_recorded', 'recorded'].includes(row.submission_state || row.status))) {
          this.makeupRecordsError = '记录的日期、类型或状态异常，请重新查询后再申请补卡';
          return false;
        }
        const range = historicalMakeupRange();
        if ((data.server_date && data.server_date !== beijingSignDate()) ||
            (data.range_start && data.range_start !== range.start) || (data.range_end && data.range_end !== range.end)) {
          this.makeupRecordsError = '日期校验不一致，请校准设备时间并重新打开补签';
          return false;
        }
        this.makeupRecordRows = data.records;
        this.makeupApplicationRows = data.applications;
        this.makeupHistoryPhone = phone;
        return true;
      } catch (error) {
        if (isCurrent()) this.makeupRecordsError = '记录查询失败，请重新查询后再申请补卡';
        return false;
      } finally {
        if (isCurrent()) this.makeupRecordsLoading = false;
      }
    },

    makeupAdjacentMonth(offset) {
      if (!/^\d{4}-\d{2}$/.test(this.makeupCalendarMonth)) return '';
      const [year, month] = this.makeupCalendarMonth.split('-').map(Number);
      return new Date(Date.UTC(year, month - 1 + offset, 1)).toISOString().slice(0, 7);
    },

    canMoveMakeupMonth(offset) {
      const month = this.makeupAdjacentMonth(offset);
      return Boolean(month && month >= this.makeupRangeStart.slice(0, 7) && month <= this.makeupRangeEnd.slice(0, 7));
    },

    moveMakeupMonth(offset) {
      if (![-1, 1].includes(offset) || !this.canMoveMakeupMonth(offset)) return;
      this.makeupCalendarMonth = this.makeupAdjacentMonth(offset);
      this.renderMakeupCalendar();
    },

    renderMakeupCalendar() {
      const [year, month] = this.makeupCalendarMonth.split('-').map(Number);
      const first = Date.UTC(year, month - 1, 1);
      const start = first - new Date(first).getUTCDay() * 86400000;
      this.makeupCalendarDays = Array.from({ length: 42 }, (_, index) => {
        const date = new Date(start + index * 86400000).toISOString().slice(0, 10);
        const inMonth = date.slice(0, 7) === this.makeupCalendarMonth;
        return { date: inMonth ? date : '', number: inMonth ? Number(date.slice(8)) : '',
          enabled: inMonth && date >= this.makeupRangeStart && date <= this.makeupRangeEnd && isHistoricalMakeupDate(date) };
      });
    },

    selectMakeupDate(date) {
      if (this.makeupRecordsLoading || this.makeupRecordsError || !isHistoricalMakeupDate(date) ||
          date < this.makeupRangeStart || date > this.makeupRangeEnd) return false;
      this.makeupSignDate = date;
      return true;
    },

    makeupRecordDate(record) {
      const value = record.sign_date || record.attendenceTime || record.attendanceTime || record.createTime;
      return typeof value === 'string' ? value.split(/[ T]/)[0] : '';
    },

    makeupRecordState(date, signType) {
      const records = this.makeupRecordRows.filter(item => this.makeupRecordDate(item) === date &&
        (item.sign_type || item.type) === signType);
      if (records.some(item => item.status === 'recorded')) return { state: 'recorded', label: '已打卡' };
      if (records.length) return records[0].status === 'rejected'
        ? { state: 'rejected', label: '申请已驳回，请在公学芸查看原因' }
        : { state: 'pending', label: '已有申请记录，请在公学芸查看处理状态' };
      const application = this.makeupApplicationRows.find(item => item.sign_date === date && item.sign_type === signType);
      if (!application) return { state: 'none', label: '未查到记录' };
      const state = application.submission_state || application.status;
      if (state === 'submitted' || state === 'pending') return { state: 'pending', label: '申请中，请等待公学芸处理' };
      if (state === 'awaiting_auth') return { state: 'awaiting_auth', label: '需要本人完成验证' };
      if (state === 'already_recorded' || state === 'recorded') return { state: 'recorded', label: '已打卡' };
      return { state: 'unknown', label: '申请结果待确认，请先在公学芸核对' };
    },

    makeupDayMarker(date, signType) {
      const marker = { recorded: '✓', pending: '待', rejected: '拒', awaiting_auth: '验', unknown: '?', none: '—' };
      return (signType === 'START' ? '上' : '下') + marker[this.makeupRecordState(date, signType).state];
    },

    canSubmitMakeupType(signType) {
      if (!['START', 'END'].includes(signType) || !this.makeupSignAccount || !this.canUseMakeupSign(this.makeupSignAccount) ||
          this.makeupRecordsLoading || this.makeupRecordsError || this.makeupWindowDate !== beijingSignDate() ||
          this.makeupHistoryPhone !== String(this.makeupSignAccount.phone) || !isHistoricalMakeupDate(this.makeupSignDate)) return false;
      return ['none', 'awaiting_auth'].includes(this.makeupRecordState(this.makeupSignDate, signType).state);
    },

    async submitMakeupSign(signType) {
      if (!this.showMakeupSignDialog || !this.makeupSignAccount || !['START', 'END'].includes(signType)) return 'stale';
      if (this.makeupWindowDate !== beijingSignDate() || !isHistoricalMakeupDate(this.makeupSignDate)) {
        this.showMakeupSignDialog = false;
        this.showToast('请选择过去30天内的日期（不含今天），跨日后请重新打开补签');
        return 'stale';
      }
      if (!this.canUseMakeupSign(this.makeupSignAccount)) {
        this.showMakeupSignDialog = false;
        this.showToast('自动签到有效期已到期，补签仅自动剩余天数大于0可用');
        return 'expired';
      }
      if (!this.canSubmitMakeupType(signType)) {
        this.showToast('请先确认该日期的考勤和申请记录，已有考勤或待处理申请不重复提交');
        return 'blocked';
      }
      const account = this.makeupSignAccount;
      const signDate = this.makeupSignDate;
      this.showMakeupSignDialog = false;
      return this.submitCheckin(account, { tab: 'gxy', mode: 'historical_makeup', signType, signDate });
    },

    signRetryHint(operation) {
      return operation && operation.mode === 'historical_makeup'
        ? `请重新打开补签，选择${operation.signDate}的${operation.signType === 'START' ? '上班' : '下班'}卡`
        : '请手动再点一次立即打卡';
    },

    // 提交打卡
    async submitCheckin(account, options = {}) {
      const submitTab = options.tab || this.currentTab;
      const isAlipayAutoRetry = Boolean(options.isAlipayAutoRetry);
      const phone = String(account.phone);
      const requestKey = `${submitTab}:${phone}`;
      if (!this._signRequests) this._signRequests = Object.create(null);
      if (this._signRequests[requestKey]) return 'busy';
      const manager = submitTab === 'gxy' ? this.getSignOperationManager() : null;
      const intent = options.operation || (options.mode === 'historical_makeup'
        ? { mode: 'historical_makeup', signType: options.signType, signDate: options.signDate }
        : { mode: 'normal' });
      if (intent.mode === 'historical_makeup' && (!isHistoricalMakeupDate(intent.signDate) ||
          (options.operation && !isSameSignDay(options.operation.createdAt)))) {
        this.clearAccountAlipayPending(options.operation);
        this.showToast('补卡操作日期已变化，请重新打开补签并选择日期和类型');
        return 'stale';
      }
      const previousOperation = manager && manager.read(phone);
      const operation = manager ? manager.begin(phone, options.operation, intent) : null;
      if (manager && !operation) {
        this.showToast(previousOperation && !sameSignIntent(previousOperation, intent)
          ? '该账号上一笔打卡结果尚未确认，请先查询打卡记录并处理原操作'
          : (intent.mode === 'historical_makeup' ? '补卡操作已过期，请重新打开补签并选择日期和类型' : '打卡操作已更新，请重新发起'));
        return 'stale';
      }
      const isMakeup = operation && operation.mode === 'historical_makeup';
      const proxyWaitEpoch = this._manualProxyWaitEpoch || 0;
      this._signRequests[requestKey] = true;
      if (operation) {
        const pending = this.getAccountAlipayPending();
        if (pending && pending.phone === phone && pending.operation.id !== operation.id) {
          this.clearAccountAlipayPending(pending.operation);
        }
        if (pending && pending.operation.id === operation.id) {
          pending.operation = operation;
          pending.retryConsumed = true;
          this.saveAccountAlipayPending(pending);
          if (this._alipayRetryTimer) clearTimeout(this._alipayRetryTimer);
        }
      }
      try {
        if (!isAlipayAutoRetry) {
          this.showToast(isMakeup ? `正在提交${operation.signDate}${operation.signType === 'START' ? '上班' : '下班'}补卡申请...` : '打卡中...');
        }
        const endpoint = submitTab === 'xyb'
          ? API_ENDPOINTS.XYB.SUBMIT_CHECKIN
          : (isMakeup ? API_ENDPOINTS.GXY.MAKEUP_SIGN : API_ENDPOINTS.GXY.NOW_SIGN);
        const payload = { phone: account.phone };
        if (operation) {
          payload.operation_id = operation.id;
          payload.operation_step = operation.step;
          if (isMakeup) {
            payload.sign_type = operation.signType;
            payload.sign_date = operation.signDate;
          }
        }
        const request = () => axios.post(endpoint, payload, {
          timeout: submitTab === 'gxy' ? TIMEOUT_CONFIG.GXY_MANUAL_SIGN : TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        const response = submitTab === 'gxy'
          ? await waitForManualProxy(request, operation, {
            isCurrent: () => !this._manualProxyWaitStopped &&
              (this._manualProxyWaitEpoch || 0) === proxyWaitEpoch && manager.matches(phone, operation),
            onWait: () => {
              manager.mark(phone, operation, 'waiting_proxy');
              this.$set(this.manualProxyWaiting, phone, true);
              this.showToast('正在获取代理，请保持页面打开');
            },
          }) : await request();
        if (!response) {
          if (!this._manualProxyWaitStopped) this.showToast('打卡操作日期或状态已变化，请重新发起');
          return 'stale';
        }

        const responseData = response.data || {};
        const verifyData = responseData.type === 'alipay_verify'
          ? responseData
          : responseData.data;
        if (submitTab === 'gxy' && verifyData && verifyData.type === 'alipay_verify') {
          manager.mark(phone, operation, 'awaiting_auth');
          if (isMakeup && !verifyData.url) {
            this.clearAccountAlipayPending(operation);
            const challenge = String(verifyData.upstream_challenge || '');
            const verificationTip = ['303', '304'].includes(challenge)
              ? '本次补签需要额外人脸验证。'
              : (challenge === '302' ? '本次补签需要完成滑块验证。' : '本次补签需要额外验证。');
            const selectedShift = operation.signType === 'START' ? '上班' : '下班';
            Dialog.alert({
              title: '请到公学芸App完成补签',
              message: `${verificationTip}\n\n请打开公学芸App，在补签页面选择${operation.signDate}的${selectedShift}卡，按提示完成验证并提交。\n\n本次网站补签尚未完成，请在App查看申请或审批状态。`,
              confirmButtonText: '我知道了',
            }).catch(() => {});
            return 'alipay_verify';
          }
          if (isAlipayAutoRetry) {
            this.showToast('认证状态暂未生效，' + this.signRetryHint(operation));
            return 'alipay_verify';
          }
          this.showAlipayVerification(verifyData, account, operation);
          return 'alipay_verify';
        }

        if (isMakeup && responseData.code === 0 && (!responseData.data ||
            responseData.data.type !== 'makeup_application' ||
            !['submitted', 'already_recorded', 'existing_application'].includes(responseData.data.submission_state))) {
          manager.mark(phone, operation, 'retryable');
          this.showToast('补卡申请结果待确认，请先在公学芸核对申请和考勤记录');
          return 'processing';
        }
        if (responseData.code === 0 || (submitTab === 'gxy' && responseData.code === 30010)) {
          if (manager) {
            manager.mark(phone, operation, 'success');
            this.clearAccountAlipayPending(operation);
          }
          if (isMakeup) {
            const state = responseData.data && responseData.data.submission_state;
            if (state === 'existing_application') {
              const rejected = responseData.data.status === 'rejected';
              this.showToast(rejected ? '该日期补卡申请已驳回，请在公学芸查看原因，未重复提交' : '该日期已有补卡申请，请在公学芸查看处理状态，未重复提交');
              return rejected ? 'rejected_application' : 'pending_application';
            }
            this.showToast(responseData.code === 30010 || state === 'already_recorded'
              ? `${operation.signDate}${operation.signType === 'START' ? '上班' : '下班'}已有考勤记录`
              : '补卡申请已提交，最终考勤请以公学芸记录为准');
            return responseData.code === 30010 || state === 'already_recorded' ? 'already_recorded' : 'application_submitted';
          }
          this.showToast(responseData.code === 30010
            ? (responseData.message || '该类型已打卡')
            : (isAlipayAutoRetry ? '认证完成，已自动提交打卡' : (responseData.message || '打卡任务已提交')));
          return 'success';
        } else {
          if (manager) {
            manager.mark(phone, operation, responseData.code === 30015 ? 'retryable' : 'failed');
            if (responseData.code !== 30015) this.clearAccountAlipayPending(operation);
          }
          this.showToast(responseData.code === 30016 && isMakeup
            ? '补卡操作已过期或更新，请重新打开补签并选择日期和类型'
            : (responseData.message || '打卡失败'));
          return responseData.code === 30015 ? 'busy' : 'failed';
        }
      } catch (error) {
        if (manager) manager.mark(phone, operation, 'retryable');
        this.showToast(isAlipayAutoRetry
          ? '自动打卡结果暂未确认，请先查询打卡记录'
          : (isMakeup ? '补签结果暂未确认，请先在公学芸查询申请状态'
            : (submitTab === 'gxy' ? '打卡结果暂未确认，请先查询打卡记录' : '打卡失败，请稍后重试')));
        return 'network_error';
      } finally {
        this.$delete(this.manualProxyWaiting, phone);
        delete this._signRequests[requestKey];
      }
    },

    async loadXybLogs(account) {
      try {
        this.xybLogs = [];
        const response = await axios.get(API_ENDPOINTS.XYB.GET_LOGS, {
          params: { phone: account.phone, limit: 100 },
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (response.data.code === 0) {
          this.xybLogs = response.data.data || [];
          this.showXybLogsDialog = true;
        } else {
          this.showToast(response.data.message || '日志获取失败');
        }
      } catch (error) {
        console.error('获取校友邦日志失败:', error);
        this.showToast('日志获取失败，请稍后重试');
      }
    },

    // 生成专属打卡链接
    async generateShareLink(account) {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }
        this.showToast('生成中...');
        const response = await axios.post(API_ENDPOINTS.GXY.GENERATE_SHARE_TOKEN, {
          phone: account.phone
        }, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.data.code === 0) {
          this.shareLink = window.location.origin + '/s/' + response.data.data.token;
          this.showShareLinkDialog = true;
        } else {
          this.showToast(response.data.message || '生成失败');
        }
      } catch (error) {
        console.error('生成打卡链接失败:', error);
        this.showToast('生成失败，请稍后重试');
      }
    },

    copyShareLink() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.shareLink).then(() => {
          this.showToast('链接已复制');
        }).catch(() => {
          this.fallbackCopy();
        });
      } else {
        this.fallbackCopy();
      }
    },

    fallbackCopy() {
      const input = document.createElement('input');
      input.value = this.shareLink;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.showToast('链接已复制');
    },

    // 生成报告
    async generateReport(account) {
      try {
        console.log('生成报告被点击', account);
        this.showReportDialog = true;
        this.selectedAccount = account;
        
        // 重置标签页状态为生成报告
        this.activeTab = 'report';
        
        // 初始化报告表单
        const currentDate = new Date().toISOString().split('T')[0];
        const currentWeek = Math.ceil((new Date().getTime() - new Date(new Date().getFullYear(), 0, 1).getTime()) / (7 * 24 * 60 * 60 * 1000));
        const currentMonth = new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0');
        
        this.reportForm = {
          type: 'daily',
          title: '日报', // Default title
          content: '',
          phone: account.phone,
          report_type: 'day', // Default type
          report_flag: 0,
          report_title: '日报',
          report_content: '',
          reportTime: currentDate, // Set current date
          startTime: '',
          endTime: '',
          week: currentWeek, // Set current week
          yearmonth: currentMonth, // Set current month
          month: currentMonth // 新增：月份字段
        };

        // 获取周信息（为周报准备）
        await this.getWeeksDate();

        // 自动获取现有报告
        await this.getExistingReport(account.phone);
        
        console.log('弹窗状态:', this.showReportDialog);
      } catch (error) {
        console.error('生成报告失败:', error);
        this.showToast('生成报告失败');
      }
    },

    // 获取现有报告
    async getExistingReport(phone) {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        const requestData = {
          phone: phone,
          report_type: this.reportForm.report_type,
          report_flag: 0,
          report_title: this.reportForm.report_title,
          report_content: '',
          reportTime: this.reportForm.reportTime,
          startTime: '',
          endTime: '',
          week: this.reportForm.week,
          yearmonth: this.reportForm.yearmonth
        };

        console.log('正在获取报告，请求参数:', requestData);
        console.log('API地址:', API_ENDPOINTS.GXY.GET_REPORT);

        // 使用POST方法，因为参数较多
        const response = await axios.post(API_ENDPOINTS.GXY.GET_REPORT, requestData, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        console.log('API响应:', response.data);

        if (response.data.code === 0 && response.data.data) {
          // 如果存在报告，填充表单
          const existingReport = response.data.data;
          this.reportForm.report_title = existingReport.report_title || this.reportForm.report_title;
          this.reportForm.report_content = existingReport.report_content || '';
          this.reportForm.title = existingReport.report_title || this.reportForm.report_title;
          this.reportForm.content = existingReport.report_content || '';
          this.reportForm.report_flag = existingReport.report_flag || 0;
          
          console.log('获取到现有报告:', existingReport);
          console.log('更新后的表单:', this.reportForm);
        } else {
          console.log('未找到现有报告，将创建新报告');
        }
      } catch (error) {
        console.error('获取现有报告失败:', error);
        if (error.response) {
          console.error('错误响应:', error.response.data);
          console.error('错误状态:', error.response.status);
        }
        // 不显示错误提示，因为可能是首次生成报告
      }
    },

    // 打卡记录
    async checkinRecord(account) {
      try {
        console.log('打卡记录被点击', account);
        // 跳转到打卡记录页面或显示记录弹窗
        this.showRecordDialog = true;
        this.selectedAccount = account;
        await this.loadCheckinRecords(account.phone);
        this.generateCalendar();
      } catch (error) {
        console.error('查看打卡记录失败:', error);
        this.showToast('查看打卡记录失败');
      }
    },

    // 加载最近报告
    async loadRecentReports(phone) {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        const requestData = {
          phone: phone,
          report_type: this.reportForm.report_type, // 获取对应类型的报告
          report_flag: 0,
          report_title: '',
          report_content: '',
          reportTime: '',
          startTime: '',
          endTime: '',
          week: 0,
          yearmonth: ''
        };

        console.log('正在获取最近报告，请求参数:', requestData);
        console.log('API地址:', API_ENDPOINTS.GXY.GET_REPORT);

        const response = await axios.post(API_ENDPOINTS.GXY.GET_REPORT, requestData, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        console.log('API响应:', response.data);

        if (response.data.code === 0 && response.data.data) {
          // 根据后端返回的数据结构，数据在 data.data 中
          const reportData = response.data.data;
          if (reportData.code === 200 && reportData.data) {
            this.recentReports = reportData.data || [];
            console.log('获取到最近报告:', this.recentReports.length, '条记录');
          } else {
            this.recentReports = [];
            console.log('未找到最近报告数据');
          }
        } else {
          this.recentReports = [];
          console.log('未找到最近报告');
        }
      } catch (error) {
        console.error('加载最近报告失败:', error);
        this.showToast('获取最近报告失败');
      }
    },

    // 修改密码
    async changePassword(account) {
      try {
        this.showPasswordDialog = true;
        this.selectedAccount = account;
        this.newPassword = '';
      } catch (error) {
        console.error('修改密码失败:', error);
        this.showToast('修改密码失败');
      }
    },

    // 删除用户
    async deleteAccount(phone) {
      try {
        this.showDeleteDialog = true;
        this.deletePhone = phone;
      } catch (error) {
        console.error('删除用户失败:', error);
        this.showToast('删除失败，请稍后重试');
      }
    },

    // 确认删除用户
    async confirmDelete() {
      try {
        this.showToast('删除中...');
        const endpoint = this.currentTab === 'xyb'
          ? API_ENDPOINTS.XYB.DEL_USER
          : API_ENDPOINTS.GXY.DEL_USER;
        const response = await axios.post(endpoint, {
          phone: this.deletePhone
        }, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data.code === 0) {
          this.showToast('删除成功');
          this.showDeleteDialog = false;
          await this.getAccountList(); // 刷新列表
        } else {
          this.showToast(response.data.message || '删除失败');
        }
      } catch (error) {
        console.error('删除用户失败:', error);
        this.showToast('删除失败，请稍后重试');
      }
    },

    // 加载打卡记录
    async loadCheckinRecords(phone) {
      try {
        const response = await axios.get(API_ENDPOINTS.GXY.GET_SIGN_HISTORIES, {
          params: { phone: phone },
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data.code === 0) {
          this.checkinRecords = response.data.data || [];
          console.log('打卡记录加载成功:', this.checkinRecords.length, '条记录');
        } else {
          this.showToast(response.data.message || '获取打卡记录失败');
        }
      } catch (error) {
        console.error('加载打卡记录失败:', error);
        this.showToast('获取打卡记录失败');
      }
    },

    // AI生成报告内容
    async generateAIContent() {
      try {
        this.showToast('AI生成中...');
        
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        // 准备发送的参数
        const aiParams = {
          phone: this.reportForm.phone,
          report_type: this.reportForm.report_type,
          report_flag: 0,
          // 添加时间相关参数
          reportTime: this.reportForm.reportTime,
          startTime: this.reportForm.startTime,
          endTime: this.reportForm.endTime,
          week: this.reportForm.week,
          yearmonth: this.reportForm.month || this.reportForm.yearmonth,
          month: this.reportForm.month
        };

        console.log('AI生成参数:', aiParams);
        console.log('当前reportForm:', this.reportForm);

        // 调用AI生成接口
        const response = await axios.post(API_ENDPOINTS.GXY.AI_GENERATE, aiParams, {
          timeout: 30000,
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.data.code === 0) {
          // 如果接口返回成功，使用返回的内容
          this.reportForm.content = response.data.data || '';
          this.showToast('AI生成完成');
        } else if (response.data.code === 20003) {
          // VIP权限过期
          this.showToast(response.data.message || 'VIP报告权限已过期');
        } else {
          // 其他错误
          this.showToast(response.data.message || 'AI生成失败');
        }
      } catch (error) {
        console.error('AI生成失败:', error);
        if (error.response && error.response.data && error.response.data.code === 20003) {
          this.showToast(error.response.data.message || 'VIP报告权限已过期');
        } else {
          this.showToast('AI生成失败，请稍后重试');
        }
      }
    },

    // 提交报告
    async submitReport() {
      try {
        if (!this.reportForm.title.trim()) {
          this.showToast('请输入报告标题');
          return;
        }
        if (!this.reportForm.content.trim()) {
          this.showToast('请输入报告内容');
          return;
        }

        this.submitting = true; // 开始提交
        this.showToast('提交中...');
        
        // 更新表单数据
        this.reportForm.report_title = this.reportForm.title;
        this.reportForm.report_content = this.reportForm.content;
        
        const response = await axios.post(API_ENDPOINTS.GXY.SUBMIT_REPORT, {
          phone: this.reportForm.phone,
          report_type: this.reportForm.report_type,
          report_flag: this.reportForm.report_flag,
          report_title: this.reportForm.report_title,
          report_content: this.reportForm.report_content,
          reportTime: this.reportForm.reportTime,
          startTime: this.reportForm.startTime,
          endTime: this.reportForm.endTime,
          week: this.reportForm.week,
          yearmonth: this.reportForm.month || this.reportForm.yearmonth, // 使用选择的月份
          month: this.reportForm.month // 新增：月份字段
        }, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data.code === 0) {
          this.showToast('报告提交成功');
          this.showReportDialog = false;
          this.reportForm = {
            type: 'daily',
            title: '',
            content: '',
            phone: '',
            report_type: 'day',
            report_flag: 0,
            report_title: '',
            report_content: '',
            reportTime: '',
            startTime: '',
            endTime: '',
            week: 0,
            yearmonth: ''
          };
          await this.loadRecentReports(this.selectedAccount.phone); // 刷新最近记录
        } else if (response.data.code === 20003) {
          // VIP权限过期
          this.showToast(response.data.message || 'VIP报告权限已过期');
        } else {
          this.showToast(response.data.message || '报告提交失败');
        }
      } catch (error) {
        console.error('提交报告失败:', error);
        if (error.response && error.response.data && error.response.data.code === 20003) {
          this.showToast(error.response.data.message || 'VIP报告权限已过期');
        } else {
          this.showToast('报告提交失败，请稍后重试');
        }
      } finally {
        this.submitting = false; // 结束提交
      }
    },

    // 确认修改密码
    async confirmChangePassword() {
      try {
        if (!this.newPassword || this.newPassword.length < 6) {
          this.showToast('密码长度不能少于6位');
          return;
        }

        this.showToast('修改中...');
        const endpoint = this.currentTab === 'xyb'
          ? API_ENDPOINTS.XYB.CHANGE_PASSWORD
          : API_ENDPOINTS.GXY.CHANGE_PASSWORD;
        const response = await axios.post(endpoint, {
          phone: this.selectedAccount.phone,
          new_password: this.newPassword
        }, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data.code === 0) {
          this.showToast('密码修改成功');
          this.showPasswordDialog = false;
          this.newPassword = '';
        } else {
          this.showToast(response.data.message || '密码修改失败');
        }
      } catch (error) {
        console.error('修改密码失败:', error);
        this.showToast('密码修改失败');
      }
    },

    // 购买套餐
    async buyPackage() {
      try {
        if (!this.selectedPackage) {
          this.showToast('请选择套餐');
          return;
        }
        if (!this.selectedPayMethod) {
          this.showToast('请选择支付方式');
          return;
        }

        if (this.selectedPayMethod === 'wechat' && this.currentTab === 'gxy') {
          this.showToast('正在创建微信支付...');
          const renewRes = await axios.post(API_ENDPOINTS.PAY.RENEW_WECHAT_PAY, {
            product_id: this.selectedPackage,
            phone: this.selectedAccount.phone
          }, {
            timeout: TIMEOUT_CONFIG.DEFAULT,
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
          });
          if (renewRes.data.code === 0 && renewRes.data.data && renewRes.data.data.url) {
            this.showPackageDialog = false;
            this.selectedPackage = '';
            window.location.href = renewRes.data.data.url;
          } else {
            this.showToast(renewRes.data.message || '创建支付失败');
          }
          return;
        }

        this.showToast('购买中...');
        const endpoint = this.currentTab === 'xyb'
          ? API_ENDPOINTS.XYB.BUY
          : API_ENDPOINTS.PAY.BUY;
        const response = await axios.post(endpoint, {
          product_id: this.selectedPackage,
          phone: this.selectedAccount.phone,
          force: true  // 允许续费，即使套餐未到期
        }, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data.code === 0) {
          this.showToast('购买成功');
          this.showPackageDialog = false;
          this.selectedPackage = '';
          await this.getAccountList(); // 刷新列表
        } else {
          this.showToast(response.data.message || '购买失败');
        }
      } catch (error) {
        console.error('购买套餐失败:', error);
        this.showToast('购买失败，请稍后重试');
      }
    },



    // 加载签到配置
    async loadSignConfig(phone) {
      try {
        const endpoint = this.currentTab === 'xyb'
          ? API_ENDPOINTS.XYB.GET_CONFIG
          : API_ENDPOINTS.GXY.GET_CONFIG;
        const response = await axios.get(endpoint, {
          params: { phone },
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data.code === 0) {
          const config = response.data.data;
          console.log('加载的配置数据:', config);
          this.signConfig = {
            address: config.address || '',
            province: config.province || '',
            city: config.city || '',
            district: config.area || '',
            detailAddress: config.address || '',
            longitude: config.longitude || '',
            latitude: config.latitude || '',
            workStartTime: config.SignStartTime || '8:00:00',
            workEndTime: config.SignEndTime || '17:30:00',
            checkinDays: Array.isArray(config.SignDayEable) ? config.SignDayEable : (config.SignDayEable ? config.SignDayEable.split(',') : ['1', '2', '3', '4', '5', '6', '7']),
            enableWorkStart: config.AutoSignStart || false,
            enableWorkEnd: config.AutoSignEnd || false,
            autoDayReport: config.AutoDayReport || false,
            autoWeekReport: config.AutoWeekReport || false,
            autoMonthReport: config.AutoMonthReport || false,
            uploadImages: config.upload_imgs || []
          };
          console.log('设置后的signConfig:', this.signConfig);
        }
      } catch (error) {
        console.error('加载签到配置失败:', error);
      }
    },

    // 保存签到设置
    async saveSignConfig() {
      try {
        this.showToast('保存中...');
        
        // 处理上传图片数据
        const processedImages = this.signConfig.uploadImages.map(img => {
          // 只保存URL，不保存整个图片对象
          if (img.imageData && img.imageData.url) {
            return { url: img.imageData.url };
          } else if (img.url) {
            return { url: img.url };
          }
          return null;
        }).filter(Boolean);
        
        console.log('准备保存的图片数据:', processedImages);
        
        const endpoint = this.currentTab === 'xyb'
          ? API_ENDPOINTS.XYB.SAVE_CONFIG
          : API_ENDPOINTS.GXY.SAVE_CONFIG;
        const response = await axios.post(endpoint, {
          phone: this.selectedAccount.phone,
          address: this.signConfig.detailAddress,  // 使用详细地址作为address
          province: this.signConfig.province,
          city: this.signConfig.city,
          area: this.signConfig.district,  // 后端期望的是area参数
          longitude: this.signConfig.longitude,
          latitude: this.signConfig.latitude,
          SignStartTime: this.signConfig.workStartTime,
          SignEndTime: this.signConfig.workEndTime,
          SignDayEable: this.signConfig.checkinDays,
          AutoSignStart: this.signConfig.enableWorkStart,
          AutoSignEnd: this.signConfig.enableWorkEnd,
          AutoDayReport: this.signConfig.autoDayReport,
          AutoWeekReport: this.signConfig.autoWeekReport,
          AutoMonthReport: this.signConfig.autoMonthReport,
          upload_imgs: processedImages
        }, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        console.log('配置保存响应:', response.data);

        if (response.data.code === 0) {
          this.showToast('签到设置保存成功');
          this.showSettingDialog = false;
        } else {
          this.showToast(response.data.message || '签到设置保存失败');
        }
      } catch (error) {
        console.error('保存签到设置失败:', error);
        this.showToast('保存签到设置失败');
      }
    },

    // 图片上传后处理
    afterRead(file) {
      console.log('上传的文件:', file);
      // 如果是多个文件
      if (Array.isArray(file)) {
        file.forEach(item => {
          this.uploadSingleImage(item);
        });
      } else {
        this.uploadSingleImage(file);
      }
    },

    // 上传单个图片
    async uploadSingleImage(file) {
      try {
        // 显示上传中状态
        file.status = 'uploading';
        file.message = '上传中...';

        // 1. 获取上传token
        const tokenResponse = await axios.post(API_ENDPOINTS.GXY.GET_UPLOAD_TOKEN, {
          phone: this.selectedAccount.phone
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (tokenResponse.data.code !== 0) {
          throw new Error(tokenResponse.data.message || '获取上传token失败');
        }

        const uploadData = tokenResponse.data.data;
        console.log('上传凭证:', uploadData);

        // 2. 上传到云存储
        const imageUrl = await this.uploadToCloudStorage(file.file, uploadData);

        // 3. 构造图片数据（只保存URL，不保存base64）
        const imageData = {
          url: imageUrl,
          name: file.file.name,
          size: file.file.size
        };

        // 上传成功
        file.status = 'done';
        file.url = imageUrl;
        file.imageData = imageData;
        this.showToast('图片上传成功');
        
        console.log('图片上传成功，URL:', imageUrl);

      } catch (error) {
        console.error('图片上传失败:', error);
        file.status = 'failed';
        file.message = '上传失败';
        this.showToast(error.message || '图片上传失败');
      }
    },

    // 上传到云存储
    async uploadToCloudStorage(file, uploadData) {
      const { token, key, image_picker } = uploadData;

      try {
        // 创建FormData
        const formData = new FormData();
        formData.append('token', token);
        formData.append('key', key);
        formData.append('file', file, image_picker || file.name);

        // 添加七牛云需要的额外字段
        formData.append('x-qn-meta-fname', image_picker);

        // 上传到七牛云
        const response = await axios.post('https://up.qiniup.com/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'host': 'up.qiniup.com',
            'accept-encoding': 'gzip',
            'user-agent': 'Dart / 2.17(dart:io)'
          },
          timeout: 30000 // 30秒超时
        });

        console.log('七牛云上传响应:', response.data);

        if (response.data && response.data.key) {
          // 直接使用完整的URL，不要去掉upload/前缀
          const fullImageUrl = `https://qiniu.gongxueyun.com/${response.data.key}`;
          console.log('生成的完整图片URL:', fullImageUrl);
          return fullImageUrl;
        } else {
          throw new Error('七牛云上传失败：响应格式异常');
        }
      } catch (error) {
        console.error('七牛云上传失败:', error);
        throw new Error(`图片上传失败: ${error.message}`);
      }
    },

    // 文件转base64
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    // 删除图片前确认
    beforeDelete() {
      return new Promise((resolve) => {
        Dialog.confirm({
          title: '确认删除',
          message: '确定要删除这张图片吗？'
        }).then(() => {
          resolve(true);
        }).catch(() => {
          resolve(false);
        });
      });
    },

    // 生成日历
    generateCalendar() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      // 设置当前月份年份显示
      this.currentMonthYear = `${currentYear}年${currentMonth + 1}月`;

      // 获取当月第一天和最后一天
      const firstDay = new Date(currentYear, currentMonth, 1);
      const lastDay = new Date(currentYear, currentMonth + 1, 0);

      // 获取第一天是星期几（0是星期日）
      const firstDayWeek = firstDay.getDay();

      // 生成日历数组
      const days = [];

      // 添加上个月的剩余天数
      for (let i = firstDayWeek - 1; i >= 0; i--) {
        days.push({ date: null, dayNumber: '', isCurrent: false, hasRecord: false, isSelected: false });
      }

      // 添加当月的天数
      for (let day = 1; day <= lastDay.getDate(); day++) {
        const date = new Date(currentYear, currentMonth, day);
        const dateString = this.formatDateString(date);
        const isCurrent = day === now.getDate() && currentMonth === now.getMonth() && currentYear === now.getFullYear();
        const hasRecord = this.checkinRecords.some(record => {
          const recordDate = record.createTime.split(' ')[0];
          return recordDate === dateString;
        });

        days.push({
          date: dateString,
          dayNumber: day,
          isCurrent,
          hasRecord,
          isSelected: false
        });
      }

      // 补充下个月的天数，确保日历是7的倍数
      const remainingDays = 42 - days.length; // 6行7列 = 42
      for (let i = 0; i < remainingDays; i++) {
        days.push({ date: null, dayNumber: '', isCurrent: false, hasRecord: false, isSelected: false });
      }

      this.calendarDays = days;
    },

    // 选择日期
    selectDate(day) {
      if (!day.date) return;

      // 清除之前的选择
      this.calendarDays.forEach(d => d.isSelected = false);
      day.isSelected = true;

      this.selectedDate = day.date;
      this.loadSelectedDateRecords(day.date);
    },

    // 加载选中日期的记录
    loadSelectedDateRecords(date) {
      this.selectedDateRecords = this.checkinRecords.filter(record => {
        const recordDate = record.createTime.split(' ')[0];
        return recordDate === date;
      }).sort((a, b) => new Date(a.createTime) - new Date(b.createTime));
    },

    // 格式化日期字符串
    formatDateString(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 格式化选中日期显示
    formatSelectedDate() {
      if (!this.selectedDate) return '';
      const date = new Date(this.selectedDate);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${month}月${day}日`;
    },

    // 格式化时间显示
    formatTime(dateTimeString) {
      if (!dateTimeString) return '';
      const time = dateTimeString.split(' ')[1];
      return time.substring(0, 5); // 只显示时:分
    },

    // 格式化手机号
    formatPhone(phone) {
      if (!phone) return '';
      return phone.toString().replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },

    // 获取状态样式类
    accountExpiryMillis(value) {
      return this.currentTab === 'gxy' ? this.makeupExpiryMillis(value) : new Date(value).getTime();
    },

    getStatusClass(vipEndTime) {
      if (!vipEndTime) return 'status-expired';
      return this.accountExpiryMillis(vipEndTime) > Date.now() ? 'status-active' : 'status-expired';
    },

    // 获取状态文本
    getStatusText(vipEndTime) {
      const expiredText = this.currentTab === 'gxy' ? '云手机过期' : '套餐到期';
      const activeText = this.currentTab === 'gxy' ? '云手机有效' : '套餐有效';
      if (!vipEndTime) return expiredText;
      return this.accountExpiryMillis(vipEndTime) > Date.now() ? activeText : expiredText;
    },

    // 获取剩余天数
    getRemainingDays(vipEndTime) {
      if (!vipEndTime) return 0;
      try {
        const timeDiff = this.accountExpiryMillis(vipEndTime) - Date.now();
        const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        return daysDiff > 0 ? daysDiff : 0;
      } catch (error) {
        return 0;
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).replace(/\//g, '-');
      } catch (error) {
        return dateString;
      }
    },

    // 生成描述信息
    generateDescription(account) {
      const parts = [];

      if (account.PlanName) {
        parts.push(account.PlanName);
      }

      if (account.schoolName) {
        parts.push(account.schoolName);
      }

      if (account.className) {
        parts.push(account.className);
      }

      return parts.join(' - ');
    },

    // 切换账户的展开/收起状态
    toggleAccount(index) {
      this.accounts[index].expanded = !this.accounts[index].expanded;
    },

    // 报告类型变化时更新表单
    async onReportTypeChange(value) {
      const typeMap = {
        'daily': { report_type: 'day', report_title: '日报' },
        'weekly': { report_type: 'week', report_title: '周报' },
        'monthly': { report_type: 'month', report_title: '月报' }
      };

      const config = typeMap[value];
      if (config) {
        this.reportForm.report_type = config.report_type;
        this.reportForm.report_title = config.report_title;
        this.reportForm.title = config.report_title;
        this.reportForm.content = ''; // 清空内容

        // 根据类型设置默认时间值
        const currentDate = new Date().toISOString().split('T')[0];
        const currentMonth = new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0');

        if (value === 'daily') {
          this.reportForm.reportTime = currentDate;
        } else if (value === 'monthly') {
          this.reportForm.month = currentMonth;
          this.reportForm.yearmonth = currentMonth;
        }

        console.log('报告类型已更改为:', config.report_type, config.report_title);

        // 如果是周报，获取周信息
        if (value === 'weekly' && this.selectedAccount) {
          await this.getWeeksDate();
        }

        // 重新获取对应类型的报告
        if (this.selectedAccount) {
          this.getExistingReport(this.selectedAccount.phone);
        }
      }
    },

    // 获取报告类型文本
    getReportTypeText(type) {
      switch (type) {
        case 'day':
          return '日报';
        case 'week':
          return '周报';
        case 'month':
          return '月报';
        default:
          return '未知';
      }
    },

    // 获取周信息
    async getWeeksDate() {
      if (!this.selectedAccount) return;

      try {
        const response = await axios.post(API_ENDPOINTS.GXY.GET_WEEKS_DATE, {
          phone: this.selectedAccount.phone
        }, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data.code === 0) {
          const weeks = response.data.data;
          if (weeks && weeks.length > 0) {
            // 存储周次数据
            this.weeksData = weeks;

            // 找到当前周或默认周
            const currentWeek = weeks.find(week => week.isDefault === 1) || weeks[weeks.length - 1];

            // 更新表单中的周信息
            this.reportForm.week = currentWeek.weekNumber;
            this.reportForm.startTime = currentWeek.startTime;
            this.reportForm.endTime = currentWeek.endTime;

            console.log('获取周信息成功:', currentWeek);
            console.log('所有周次数据:', weeks);
          }
        } else {
          console.error('获取周信息失败:', response.data.message);
          this.showToast(response.data.message || '获取周信息失败');
        }
      } catch (error) {
        console.error('获取周信息异常:', error);
        this.showToast('获取周信息失败，请稍后重试');
      }
    },

    // 打开周次选择器
    openWeekSelector() {
      if (this.weeksData.length === 0) {
        this.showToast('周次数据加载中，请稍后再试');
        return;
      }

      // 使用Dialog显示选择器
      this.$dialog.confirm({
        title: '选择周次',
        message: this.createWeekList(),
        allowHtml: true,
        confirmButtonText: '关闭'
      });
    },

    // 创建周次列表
    createWeekList() {
      // 保存当前组件实例的引用
      const vm = this;

      let html = '<div style="text-align: left; max-height: 300px; overflow-y: auto;">';
      this.weeksData.forEach((week, index) => {
        const isSelected = week.weekNumber === this.reportForm.week;
        const style = isSelected ?
          'background: #00CB6A; color: white; padding: 10px; margin: 2px 0; border-radius: 4px; cursor: pointer;' :
          'background: #f5f5f5; padding: 10px; margin: 2px 0; border-radius: 4px; cursor: pointer;';

        html += `<div style="${style}" onclick="window.selectWeek_${index}()">
          第${week.weekNumber}周 (${week.startTime.split(' ')[0]} ~ ${week.endTime.split(' ')[0]})
        </div>`;

        // 为每个周次创建独立的选择函数
        window[`selectWeek_${index}`] = () => {
          console.log('点击选择周次:', week.weekNumber, '开始时间:', week.startTime, '结束时间:', week.endTime);

          // 使用Vue.set确保响应式更新
          vm.$set(vm.reportForm, 'week', week.weekNumber);
          vm.$set(vm.reportForm, 'startTime', week.startTime);
          vm.$set(vm.reportForm, 'endTime', week.endTime);

          // 强制更新组件
          vm.$forceUpdate();

          vm.$dialog.close();

          console.log('更新后的reportForm:', {
            week: vm.reportForm.week,
            startTime: vm.reportForm.startTime,
            endTime: vm.reportForm.endTime
          });
        };
      });
      html += '</div>';

      return html;
    },

    // 打开日期选择器
    openDateSelector() {
      // 生成最近30天的日期选项
      const dates = [];
      const today = new Date();
      for (let i = 29; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        const dateStr = date.toISOString().split('T')[0];
        dates.push({
          text: `${dateStr} (${i === 0 ? '今天' : i + '天前'})`,
          value: dateStr
        });
      }

      this.createDateList(dates);
    },

    // 创建日期列表
    createDateList(dates) {
      const vm = this;

      let html = '<div style="text-align: left; max-height: 300px; overflow-y: auto;">';
      dates.forEach((date, index) => {
        const isSelected = date.value === this.reportForm.reportTime;
        const style = isSelected ?
          'background: #00CB6A; color: white; padding: 10px; margin: 2px 0; border-radius: 4px; cursor: pointer;' :
          'background: #f5f5f5; padding: 10px; margin: 2px 0; border-radius: 4px; cursor: pointer;';

        html += `<div style="${style}" onclick="window.selectDate_${index}()">
          ${date.text}
        </div>`;

        // 为每个日期创建独立的选择函数
        window[`selectDate_${index}`] = () => {
          console.log('点击选择日期:', date.value);
          vm.$set(vm.reportForm, 'reportTime', date.value);
          vm.$forceUpdate();
          vm.$dialog.close();
          console.log('更新后的reportTime:', vm.reportForm.reportTime);
        };
      });
      html += '</div>';

      // 使用Dialog显示选择器
      this.$dialog.confirm({
        title: '选择日期',
        message: html,
        allowHtml: true,
        confirmButtonText: '关闭'
      });
    },

    // 打开月份选择器
    openMonthSelector() {
      // 生成最近12个月的月份选项
      const months = [];
      const today = new Date();
      for (let i = 11; i >= 0; i--) {
        const date = new Date(today);
        date.setMonth(today.getMonth() - i);
        const monthStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        months.push({
          text: `${monthStr} (${i === 0 ? '本月' : i + '个月前'})`,
          value: monthStr
        });
      }

      this.createMonthList(months);
    },

    // 创建月份列表
    createMonthList(months) {
      const vm = this;

      let html = '<div style="text-align: left; max-height: 300px; overflow-y: auto;">';
      months.forEach((month, index) => {
        const isSelected = month.value === this.reportForm.month;
        const style = isSelected ?
          'background: #00CB6A; color: white; padding: 10px; margin: 2px 0; border-radius: 4px; cursor: pointer;' :
          'background: #f5f5f5; padding: 10px; margin: 2px 0; border-radius: 4px; cursor: pointer;';

        html += `<div style="${style}" onclick="window.selectMonth_${index}()">
          ${month.text}
        </div>`;

        // 为每个月份创建独立的选择函数
        window[`selectMonth_${index}`] = () => {
          console.log('点击选择月份:', month.value);
          vm.$set(vm.reportForm, 'month', month.value);
          vm.$set(vm.reportForm, 'yearmonth', month.value);
          vm.$forceUpdate();
          vm.$dialog.close();
          console.log('更新后的month:', vm.reportForm.month);
        };
      });
      html += '</div>';

      // 使用Dialog显示选择器
      this.$dialog.confirm({
        title: '选择月份',
        message: html,
        allowHtml: true,
        confirmButtonText: '关闭'
      });
    },

    // 获取周次显示文本
    getWeekDisplayText() {
      if (!this.reportForm.week) {
        return '请选择周次';
      }

      // 查找对应的周次数据
      const weekData = this.weeksData.find(week => week.weekNumber === this.reportForm.week);
      if (weekData && weekData.startTime && weekData.endTime) {
        const startDate = weekData.startTime.split(' ')[0];
        const endDate = weekData.endTime.split(' ')[0];
        return `第${this.reportForm.week}周 (${startDate} ~ ${endDate})`;
      }

      return `第${this.reportForm.week}周`;
    },

    // 格式化报告内容（截取前100个字符）
    formatReportContent(content) {
      if (!content) return '暂无内容';
      if (content.length <= 100) return content;
      return content.substring(0, 100) + '...';
    },

    // 切换标签页
    switchReportTab(tab) {
      this.activeTab = tab;
      if (tab === 'recent') {
        // 切换到最近记录标签页时加载数据
        this.loadRecentReports(this.selectedAccount.phone);
      }
    },

    // 打开地址搜索弹窗
    openAddressSearch() {
      this.showAddressSearchDialog = true;
    },

    // 地址选择回调
    onAddressSelect(addressInfo) {
      console.log('选择的地址信息:', addressInfo);
      
      // 更新签到配置中的地址信息
      this.signConfig.address = addressInfo.name;
      this.signConfig.province = addressInfo.province;
      this.signConfig.city = addressInfo.city;
      this.signConfig.district = addressInfo.district;
      this.signConfig.detailAddress = addressInfo.fullAddress;
      this.signConfig.longitude = addressInfo.longitude;
      this.signConfig.latitude = addressInfo.latitude;
      
      this.showToast('地址信息已更新');
    },

    // 刷新用户信息
    async refreshUser(account) {
      try {
        this.showToast('刷新中...');
        
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        const response = await axios.post(API_ENDPOINTS.GXY.REFRESH_USER, {
          phone: account.phone
        }, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.data.code === 0) {
          this.showToast('刷新成功');
          // 刷新成功后重新获取账号列表
          await this.getAccountList();
        } else if (response.data.code === 20002) {
          this.showToast('账户未找到');
        } else if (response.data.code === 21003) {
          // 显示计划选择弹窗
          this.planSelectData.account = account;
          this.planSelectData.plans = response.data.data || [];
          this.showPlanSelectDialog = true;
        } else {
          this.showToast(response.data.message || '刷新失败');
        }
      } catch (error) {
        console.error('刷新用户信息失败:', error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          this.$router.push('/lanhu_yonghudenglu');
        } else {
          this.showToast('刷新失败，请稍后重试');
        }
      }
    },

    // 选择计划
    async selectPlan() {
      try {
        if (!this.selectedPlanId) {
          this.showToast('请选择一个计划');
          return;
        }

        this.showToast('设置中...');
        
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        const response = await axios.post(API_ENDPOINTS.GXY.SET_PLAN_ID, {
          phone: this.planSelectData.account.phone,
          plan_id: this.selectedPlanId
        }, {
          timeout: TIMEOUT_CONFIG.DEFAULT,
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.data.code === 0) {
          this.showToast('计划设置成功');
          this.showPlanSelectDialog = false;
          this.selectedPlanId = '';
          // 重新获取账号列表以更新信息
          await this.getAccountList();
        } else {
          this.showToast(response.data.message || '计划设置失败');
        }
      } catch (error) {
        console.error('设置计划失败:', error);
        this.showToast('设置计划失败，请稍后重试');
      }
    },

    // 格式化计划时间
    formatPlanTime(startTime, endTime) {
      if (!startTime || !endTime) return '';
      
      const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      };
      
      return `${formatDate(startTime)} 至 ${formatDate(endTime)}`;
    }
  },
  watch: {
    // 监听弹窗关闭，重置标签页状态
    showReportDialog(newVal) {
      if (!newVal) {
        // 弹窗关闭时重置为生成报告标签页
        this.activeTab = 'report';
      }
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* 整体页面样式 */
.page {
  background-color: #f5f5f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* 防止页面整体滚动 */
}

/* 头部区域样式 */
.box_1 {
  background: linear-gradient(135deg, #E8F5E8 0%, #D4F1D4 100%) !important;
  padding: 20px 15px 40px 15px;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 2px 10px rgba(0, 203, 106, 0.1);
  flex-shrink: 0;
  /* 防止头部被压缩 */
  margin-bottom: -135px;
  /* 让背景延伸到数据区域 */
}

/* 选项卡样式 */
.section_2 {
  margin-bottom: 16px;
}

.text-wrapper_1 {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 8px;
}

.text_2,
.text_3 {
  width: 48px;
  height: 24px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 16px;
  color: #00CB6A;
  text-align: left;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text_2.active,
.text_3.active {
  color: #00CB6A;
  font-weight: bold;
}

.text_2:hover,
.text_3:hover {
  color: #00CB6A;
  opacity: 0.8;
}

/* 选项卡指示器 */
.box_4 {
  display: flex;
  justify-content: center;
}

.block_1 {
  width: 24px;
  height: 4px;
  background: #00CB6A;
  border-radius: 30px;
  transition: all 0.3s ease;
}

.tab-indicator-gxy {
  margin-left: -4px;
}

.tab-indicator-xyb {
  margin-left: 160px;
}

/* 搜索区域样式 */
.section_3 {
  display: flex !important;
  align-items: center !important;
  background-color: transparent !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

.search-container {
  position: relative;
  width: 110%;
  height: 42px;
  background: #FFFFFF;
  border-radius: 8px;
  margin: 13px auto 0;
  display: flex;
  align-items: center;
}

.search-input {
  flex: 1;
  height: 27px;
  padding: 0 0 0 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  box-shadow: none;
  box-sizing: border-box;
  font-size: 16px;
}

.search-input .van-field__control {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #BEBEBE;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.search-button {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background: #00CB6A;
  color: white;
  border-radius: 8px;
  padding: 0;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 34px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 203, 106, 0.3);
}

.search-button:hover {
  transform: translateY(-50%) scale(1.05);
  box-shadow: 0 4px 15px rgba(0, 203, 106, 0.4);
}

.text_5 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 14px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

/* 账户列表样式 */
.accounts-container {
  flex: 1;
  overflow-y: auto;
  /* 允许内容滚动 */
  padding: 0 15px 100px 15px;
  /* 减少顶部内边距，让头部背景延伸 */
  -webkit-overflow-scrolling: touch;
  /* iOS滚动优化 */
  position: relative;
  z-index: 1;
  /* 确保内容在头部背景之上 */
}

.account-item {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  position: relative;
  /* 用于定位展开/收起图标 */
}

.account-item:first-child {
  margin-top: 0;
  /* 第一个卡片紧贴头部背景 */
}

.account-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.account-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  cursor: pointer;
  /* 添加鼠标指针样式 */
  padding-right: 50px;
  /* 为展开图标留出空间 */
  transition: background-color 0.2s ease;
}

.account-header:hover {
  background-color: rgba(0, 203, 106, 0.05);
  border-radius: 8px;
  padding: 8px 58px 8px 8px;
  /* 调整右侧内边距，为展开图标留出更多空间 */
  margin: -8px -8px 12px -8px;
}

.account-info-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.account-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
  /* 名字和手机号之间的间距 */
}

.account-name {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 16px;
  color: #152C07;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.account-phone {
  color: #666;
  font-size: 14px;
  font-weight: 500;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
}

.account-class-row {
  display: flex;
  align-items: center;
  gap: 12px;
  /* 班级和状态标签之间的间距 */
}

.account-class {
  height: 20px;
  background: #00CB6A;
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.account-tags {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
  margin-right: 50px;
  /* 为展开图标留出空间 */
}

.tag {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  min-width: 80px;
}

.status-tag {
  width: 68px;
  height: 20px;
  background: #F26666;
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.status-active {
  background: #00CB6A;
}

.status-expired {
  background: #F26666;
}

/* 状态容器样式 */
.status-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* 剩余天数标签样式 */
.remaining-days-tag {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  color: #1890ff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  display: inline-block;
}

.account-plan {
  margin-bottom: 20px;
  padding: 16px;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 12px;
  border-left: 4px solid #00CB6A;
}

.plan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.plan-date-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.plan-title {
  font-weight: 700;
  font-size: 16px;
  color: #1a1a1a;
}

.plan-date {
  font-size: 13px;
  color: #666;
  font-weight: 500;
  background: rgba(0, 203, 106, 0.1);
  padding: 4px 8px;
  border-radius: 6px;
}

.refresh-plan-btn {
  background: #00CB6A;
  color: white;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
}

.refresh-plan-btn:hover {
  background: #00b85c;
  transform: scale(1.1);
}

.refresh-plan-btn:active {
  transform: scale(0.95);
}

.plan-description {
  font-size: 14px;
  color: #555;
  line-height: 1.5;
  font-weight: 500;
}

.makeup-entitlement-tip {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #888;
}

.makeup-entry:disabled,
.makeup-entry:disabled:hover,
.makeup-sign-button:disabled {
  color: #999;
  background: #f0f0f0;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.history-makeup-dialog {
  /* Keep this calendar independent of flexible.js root rem scaling. */
  top: 50%;
  width: calc(100% - 32 * 1px);
  max-width: calc(520 * 1px);
  max-height: calc(100vh - 32 * 1px);
}

.history-makeup-dialog ::v-deep .van-dialog__header {
  position: relative;
  padding: calc(16 * 1px) calc(20 * 1px) calc(12 * 1px);
  background: #fff;
  font-size: calc(18 * 1px);
  line-height: 1.4;
}

.history-makeup-dialog ::v-deep .van-dialog__content {
  min-height: 0;
  overflow: hidden;
}

.makeup-sign-content {
  display: flex;
  flex-direction: column;
  padding: 0 calc(16 * 1px) calc(14 * 1px);
  max-height: calc(100vh - 144 * 1px);
  overflow: hidden;
  color: #555;
  font-size: calc(14 * 1px);
  line-height: 1.6;
}

.makeup-history-scroll {
  min-height: 0;
  max-height: 56vh;
  overflow-y: auto;
  flex-shrink: 1;
  overscroll-behavior: contain;
  padding: 0 calc(2 * 1px);
}

.makeup-submit-actions {
  display: grid;
  flex-shrink: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: calc(8 * 1px);
  padding-top: calc(12 * 1px);
  margin-top: calc(8 * 1px);
  border-top: 1px solid #edf0ed;
  background: #fff;
}

.makeup-submit-actions .makeup-selected-date,
.makeup-submit-actions .makeup-load-state {
  grid-column: 1 / -1;
}

.makeup-submit-actions .makeup-sign-button {
  margin-top: 0;
  min-height: calc(44 * 1px);
  font-size: calc(14 * 1px);
}

.history-makeup-dialog .makeup-entitlement-tip {
  margin-top: calc(8 * 1px);
  font-size: calc(12 * 1px);
}

.makeup-range-tip,
.makeup-calendar-legend,
.makeup-load-state {
  margin: calc(8 * 1px) 0;
  font-size: calc(12 * 1px);
  color: #68736b;
}

.makeup-month-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: calc(10 * 1px) 0 calc(6 * 1px);
}

.makeup-month-nav button {
  min-width: calc(36 * 1px);
  min-height: calc(36 * 1px);
  font-size: calc(24 * 1px);
  color: #218954;
}

.makeup-month-nav button:disabled {
  color: #bbb;
}

.makeup-weekdays,
.makeup-calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: calc(2 * 1px);
  text-align: center;
}

.makeup-weekdays {
  margin-bottom: calc(6 * 1px);
  color: #888;
  font-size: calc(12 * 1px);
}

.makeup-calendar-day {
  width: 100%;
  min-width: 0;
  height: calc(44 * 1px);
  min-height: 0;
  padding: calc(2 * 1px) 0;
  border-radius: calc(6 * 1px);
  font-size: calc(13 * 1px);
  color: #26392d;
  background: #f3f8f4;
}

.makeup-calendar-day span,
.makeup-calendar-day small {
  display: block;
}

.makeup-calendar-day small {
  font-size: calc(9 * 1px);
  line-height: 1.6;
  white-space: nowrap;
}

.makeup-calendar-day:disabled {
  color: #c1c5c2;
  background: transparent;
}

.makeup-calendar-day.selected {
  background: #d4f2df;
  outline: 1px solid #3fac72;
}

.makeup-selected-date {
  padding: calc(8 * 1px) calc(12 * 1px);
  border-radius: calc(8 * 1px);
  background: #f3f8f4;
  font-size: calc(13 * 1px);
}

.makeup-selected-date p {
  margin: calc(4 * 1px) 0 0;
}

.makeup-load-error {
  color: #b45534;
  font-size: calc(13 * 1px);
}

.makeup-reload-button {
  padding: calc(8 * 1px) calc(14 * 1px);
  border: 1px solid #d2ded5;
  border-radius: calc(6 * 1px);
  color: #218954;
}

.makeup-sign-date {
  color: #152C07;
  font-weight: 600;
  margin: calc(4 * 1px) 0;
  font-size: calc(14 * 1px);
}

.makeup-sign-button {
  display: block;
  width: 100%;
  min-height: calc(44 * 1px);
  margin-top: calc(12 * 1px);
  border-radius: calc(8 * 1px);
  color: #152C07;
  background: rgba(0, 203, 106, 0.12);
  font-size: calc(15 * 1px);
}

.account-actions {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.action-btn {
  width: 72px;
  height: 34px;
  background: rgba(0, 203, 106, 0.1);
  color: #152C07;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: rgba(0, 203, 106, 0.2);
  color: #00CB6A;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 203, 106, 0.2);
}

.action-btn.danger {
  background: rgba(255, 77, 79, 0.1);
  color: #152C07;
}

.action-btn.danger:hover {
  background: rgba(255, 77, 79, 0.2);
  color: #ff4d4f;
  box-shadow: 0 2px 8px rgba(255, 77, 79, 0.2);
}

.action-btn.renew {
  background: linear-gradient(135deg, #ff7a45 0%, #ff4d4f 100%);
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(255, 77, 79, 0.35);
}

.action-btn.renew:hover {
  background: linear-gradient(135deg, #ff8a5c 0%, #ff6466 100%);
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 77, 79, 0.45);
}

.action-btn.renew.renew-expired {
  animation: renewPulse 1.6s ease-in-out infinite;
}

@keyframes renewPulse {
  0%, 100% { box-shadow: 0 2px 6px rgba(255, 77, 79, 0.35); }
  50% { box-shadow: 0 2px 16px rgba(255, 77, 79, 0.8); }
}

/* 折叠/展开图标样式 */
.expand-icon {
  position: absolute;
  right: 20px;
  top: 35px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.expand-icon:hover {
  transform: scale(1.1);
}

.expand-icon.expanded {
  transform: none;
}

.expand-icon.expanded:hover {
  transform: scale(1.1);
}

.arrow-icon {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 8px solid #00CB6A;
  transition: all 0.3s ease;
}

.expand-icon.expanded .arrow-icon {
  border-bottom: none;
  border-top: 8px solid #00CB6A;
}

/* 图片样式（备选方案） */
.icon-image {
  width: 50%;
  height: 50%;
  object-fit: contain;
}

/* 无数据和加载状态 */
.no-data,
.loading {
  text-align: center;
  padding: 100px 20px;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

.no-data p,
.loading p {
  font-size: 18px;
  margin: 0;
  color: #999;
  font-weight: 500;
}

/* 打卡记录样式 */
.checkin-record-item {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

/* 签到设置弹窗样式 */
.sign-config .van-field {
  margin-bottom: 15px;
}

.sign-config .van-field__label {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.sign-config .van-field__control {
  font-size: 16px;
  color: #555;
}

.sign-config .van-field__control::placeholder {
  color: #999;
}

/* 地址搜索相关样式 */
.address-search-wrapper {
  margin-bottom: 16px;
}

.address-search-wrapper .van-field {
  margin-bottom: 8px;
}

.address-search-wrapper .van-field__control {
  cursor: pointer;
  color: #333 !important;
}

.address-search-wrapper .van-field__control::placeholder {
  color: #00CB6A !important;
  font-weight: 500;
}

.search-tip {
  font-size: 12px;
  color: #00CB6A;
  background: rgba(0, 203, 106, 0.1);
  padding: 8px 12px;
  border-radius: 6px;
  border-left: 3px solid #00CB6A;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.address-search-wrapper .van-button--small {
  height: 28px;
  padding: 0 12px;
  font-size: 12px;
  white-space: nowrap;
}

.address-search-wrapper .van-field--is-link {
  cursor: pointer;
}

.address-search-wrapper .van-field--is-link:hover {
  background-color: rgba(0, 203, 106, 0.05);
}

/* 响应式设计 */
@media (max-width: 480px) {
  .account-actions {
    grid-template-columns: repeat(4, 1fr);
  }

  .text-wrapper_1 {
    gap: 30px;
  }

  .text_2,
  .text_3 {
    font-size: 16px;
    padding: 10px 20px;
  }
}

/* 折叠/展开动画 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from {
  transform: translateY(-20px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  transform: translateY(0);
  opacity: 1;
}

/* 签到设置弹窗样式 */
.sign-config {
  padding: 16px;
  max-height: 60vh;
  overflow-y: auto;
  position: relative;
}

/* 滚动提示指示器 */
.scroll-indicator {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  background: rgba(0, 203, 106, 0.9);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  box-shadow: 0 2px 12px rgba(0, 203, 106, 0.3);
  opacity: 0;
  transition: all 0.3s ease;
  pointer-events: none;
}

.scroll-indicator.show {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.scroll-tip {
  display: flex;
  align-items: center;
  gap: 4px;
}

.scroll-tip .van-icon {
  font-size: 14px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-4px);
  }
  60% {
    transform: translateY(-2px);
  }
}

.config-section {
  margin-bottom: 24px;
}

.config-section h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.photo-desc {
  color: #666;
  font-size: 14px;
  margin: 8px 0;
}

.photo-upload {
  margin-top: 12px;
}

.photo-placeholder {
  width: 80px;
  height: 80px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
}

.photo-placeholder:hover {
  border-color: #1989fa;
  background: #f0f8ff;
}

.photo-placeholder .van-icon {
  font-size: 24px;
  color: #999;
}

.toggle-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.toggle-item:last-child {
  border-bottom: none;
}

.toggle-desc {
  color: #999;
  font-size: 12px;
  margin-left: 8px;
}

/* 报告表单样式 */
.report-form {
  padding: 16px;
}

.form-section {
  margin-bottom: 16px;
}

.form-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.content-area {
  position: relative;
}

.ai-generate-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #00CB6A;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.ai-generate-btn:hover {
  background: #0c7cd5;
}

.content-area textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
  font-family: inherit;
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

/* 集成后的报告弹窗样式 */
.report-container {
  padding: 16px;
  max-height: 70vh;
  overflow-y: auto;
}

.report-type-selector {
  margin-bottom: 20px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.refresh-btn {
  background: #00CB6A;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.recent-reports-section {
  margin-bottom: 24px;
}

.recent-reports-list {
  max-height: 200px;
  overflow-y: auto;
}

.report-form-section {
  border-top: 1px solid #eee;
  padding-top: 16px;
}

.form-actions {
  margin-top: 16px;
  text-align: center;
}

/* 日历样式 */
.calendar-container {
  padding: 16px;
  max-height: 70vh;
  overflow-y: auto;
}

.calendar-header {
  text-align: center;
  margin-bottom: 16px;
}

.month-year {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  margin-bottom: 8px;
}

.weekdays span {
  text-align: center;
  font-size: 14px;
  color: #666;
  padding: 8px 0;
  font-weight: 500;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.calendar-day {
  position: relative;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.calendar-day:hover:not(.empty) {
  background-color: #f0f8ff;
  border-color: #1989fa;
}

.calendar-day.empty {
  cursor: default;
}

.calendar-day.current {
  background-color: #1989fa;
  color: white;
  font-weight: 600;
}

.calendar-day.has-record {
  border: 2px solid #00CB6A;
}

.calendar-day.selected {
  background-color: #e6f7ff;
  border-color: #1989fa;
  color: #1989fa;
  font-weight: 600;
}

.calendar-day.selected.current {
  background-color: #1989fa;
  color: white;
}

.day-number {
  font-size: 14px;
  font-weight: 500;
}

.record-indicator {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 6px;
  height: 6px;
  background-color: #00CB6A;
  border-radius: 50%;
}

/* 选中日期记录样式 */
.selected-date-records {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.selected-date-records h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.record-item {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
}

.record-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.time {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.type {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.type.start {
  background-color: #e6f7ff;
  color: #1989fa;
}

.type.end {
  background-color: #fff7e6;
  color: #fa8c16;
}

.record-address {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

/* 删除确认弹窗样式 */
.delete-dialog .van-dialog__content {
  padding: 0;
}

.delete-warning {
  padding: 24px;
  text-align: center;
}

.warning-icon {
  font-size: 32px;
  margin-bottom: 16px;
}

.warning-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.warning-message {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 24px;
  text-align: left;
}

.delete-actions {
  display: flex;
  border-top: 1px solid #f0f0f0;
  margin: 0 -24px -24px -24px;
}

.delete-cancel,
.delete-confirm {
  flex: 1;
  height: 48px;
  border: none;
  background: white;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.delete-cancel {
  color: #666;
}

.delete-confirm {
  color: #ff4d4f;
  font-weight: 600;
}

.delete-cancel:hover {
  background-color: #f5f5f5;
}

.delete-confirm:hover {
  background-color: #fff1f0;
}

.action-divider {
  width: 1px;
  background-color: #f0f0f0;
}

/* 报告相关样式 */
.no-reports-message {
  text-align: center;
  color: #999;
  padding: 20px;
  font-size: 16px;
}

.report-item {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.report-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.report-date {
  font-size: 13px;
  color: #666;
  font-weight: 500;
  background: rgba(0, 203, 106, 0.1);
  padding: 4px 8px;
  border-radius: 6px;
}

.report-content {
  font-size: 14px;
  color: #555;
  line-height: 1.5;
  font-weight: 500;
}

.report-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  font-size: 12px;
  color: #999;
}

.report-type {
  background: #e6f7ff;
  color: #1989fa;
  padding: 2px 6px;
  border-radius: 4px;
}

.report-week {
  background: #fff7e6;
  color: #fa8c16;
  padding: 2px 6px;
  border-radius: 4px;
}

.report-score {
  background: #fffbe6;
  color: #faad14;
  padding: 2px 6px;
  border-radius: 4px;
}



.view-recent-btn {
  background: #00CB6A;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.view-recent-btn:hover {
  background: #0c7cd5;
}

 .view-recent-btn .van-icon {
   margin-right: 4px;
 }

/* 标签页样式 */
.tab-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.tab-item {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-item.active {
  background-color: #00CB6A;
  color: white;
}

.tab-content {
  margin-top: 16px;
}

/* 表单样式 */
.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-section {
  margin-bottom: 20px;
}

.report-type-selector {
  margin-bottom: 20px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
}

.recent-records-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f0f8ff;
  border: 1px solid #e6f7ff;
  border-radius: 6px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.recent-records-link:hover {
  background: #e6f7ff;
}

.recent-records-link span {
  color: #1989fa;
  font-size: 14px;
}

.week-selector {
  margin-bottom: 16px;
}

.week-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.week-display:hover {
  border-color: #00CB6A;
}

.week-display span {
  color: #333;
  font-size: 14px;
}

.content-area {
  position: relative;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.ai-generate-btn {
  position: absolute;
  top: 8px;
  left: 8px;
  background: #1989fa;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  z-index: 1;
}

.content-textarea {
  width: 100%;
  min-height: 120px;
  padding: 40px 12px 30px 12px;
  border: none;
  outline: none;
  resize: vertical;
  font-size: 14px;
  line-height: 1.5;
  font-family: inherit;
}

.char-count {
  position: absolute;
  bottom: 8px;
  right: 8px;
  font-size: 12px;
  color: #999;
}

.submit-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
}

/* 选择器样式 */
.week-selector,
.date-selector,
.month-selector {
  margin-bottom: 16px;
}

.week-display,
.date-display,
.month-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.week-display:hover,
.date-display:hover,
.month-display:hover {
  border-color: #00CB6A;
}

.week-display span,
.date-display span,
.month-display span {
  color: #333;
  font-size: 14px;
}

/* 计划选择弹窗样式 */
.plan-select-content {
  padding: 16px;
  max-height: 50vh;
  overflow-y: auto;
}

.plan-select-tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 20px;
  padding: 12px;
  background: #f0f8ff;
  border-left: 3px solid #1989fa;
  border-radius: 4px;
}

.plan-select-tip .van-icon {
  color: #1989fa;
  margin-top: 2px;
  flex-shrink: 0;
}

.plan-select-tip span {
  color: #333;
  font-size: 14px;
  line-height: 1.4;
}

.plan-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  margin-bottom: 12px;
  background: #f8f9fa;
  border: 2px solid transparent;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.plan-item:hover {
  background: #e6f7ff;
  border-color: #1989fa;
}

.plan-item:last-child {
  margin-bottom: 0;
}

.plan-radio {
  margin: 0;
  flex-shrink: 0;
}

.radio-icon {
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.radio-icon.checked {
  border-color: #00CB6A;
  background: #00CB6A;
  color: white;
}

.radio-icon .van-icon {
  font-size: 12px;
}

.plan-info {
  flex: 1;
}

.plan-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  line-height: 1.3;
}

.plan-time {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
  background: rgba(0, 203, 106, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
  display: inline-block;
}

.plan-type {
  font-size: 12px;
  color: #999;
  background: #f0f0f0;
  padding: 2px 6px;
  border-radius: 3px;
  display: inline-block;
}

.share-link-content {
  padding: 16px 20px 20px;
}

.share-link-tip {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
}

.share-link-box {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 12px;
  word-break: break-all;
  margin-bottom: 16px;
}

.share-link-text {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}

.copy-link-btn {
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: #00CB6A;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.copy-link-btn:active {
  background: #00a857;
}

.auth-dialog-content {
  padding: 12px 16px 16px;
  max-height: 400px;
  overflow-y: auto;
}

.auth-dialog-desc {
  font-size: 12px;
  color: #999;
  margin-bottom: 12px;
  line-height: 1.5;
}

.auth-dialog-day {
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
}

.auth-dialog-day:last-child {
  margin-bottom: 0;
}

.auth-dialog-day-header {
  margin-bottom: 8px;
}

.auth-dialog-date {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-right: 6px;
}

.auth-dialog-weekday {
  font-size: 12px;
  color: #999;
}

.auth-dialog-slot {
  display: flex;
  align-items: center;
  padding: 6px 0;
  border-top: 1px solid #f5f5f5;
}

.auth-dialog-time {
  font-size: 13px;
  color: #333;
  font-weight: 500;
  width: 50px;
}

.auth-dialog-label {
  font-size: 12px;
  color: #666;
  flex: 1;
}

.auth-dialog-btn {
  padding: 4px 16px;
  border: none;
  border-radius: 5px;
  background: #1989fa;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}

.auth-dialog-btn:active {
  background: #1478de;
}

.auth-dialog-btn:disabled {
  background: #b0bec5;
  cursor: not-allowed;
}

.auth-status-ok {
  font-size: 12px;
  color: #00CB6A;
  font-weight: 500;
}

.xyb-log-list {
  max-height: 55vh;
  overflow-y: auto;
  padding: 12px 16px;
}

.xyb-log-item {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.xyb-log-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #333;
  font-size: 13px;
}

.xyb-log-content {
  margin-top: 6px;
  color: #666;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

</style>

<style>
.multi-gxy-tip {
  margin: 10px 16px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(0, 203, 106, 0.10);
  color: #152C07;
  display: flex;
  flex-direction: column;
  gap: 3px;
  line-height: 1.45;
}
.multi-gxy-tip strong { font-size: 14px; color: #00a85a; }
.multi-gxy-tip span { font-size: 12px; color: #58705d; }

.pkg-line { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 6px; }
.pkg-promo-tag {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 8px;
  background: #ff4d4f;
  color: #fff;
  font-size: 11px;
  line-height: 16px;
  font-weight: 600;
}
.pkg-promo-sub { display: block; margin-top: 2px; font-size: 12px; color: #9b9b9b; }
.pkg-origin { text-decoration: line-through; margin-right: 8px; color: #b5b5b5; }
.pkg-save { color: #ff6a00; font-weight: 600; font-size: 12px; }
.pkg-per-day { margin-left: 8px; color: #ff4d4f; font-size: 12px; }

.pkg-half {
  margin-top: 4px;
  padding: 8px 10px 8px 6px;
  border-radius: 10px;
  background: linear-gradient(135deg, #fff4f1, #fff9f6);
  border: 1px solid #ffd6cc;
}
.pkg-half-line {
  font-size: 15px;
  font-weight: 700;
  color: #d4380d;
}
.pkg-tag-best {
  background: #ff8c00;
  margin-left: 4px;
}
</style>
